<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindowCD">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["AFF"]["AFFS"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="5"></CCol>
                                        <CCol col="7">
                                            <label class="col-form-label-sm" style="margin-right: 20px;">{{this.getLanguage["AFF"]["ACT"]}} ?</label>
                                            <label class="switch">
                                                <input type="checkbox" true-value="2" false-value="1" v-model="obj_aaff.RS" />
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol md="5">
                                            <CRow>
                                                <CCol col="6" v-if="getUserInfo.AT !== 4">
                                                    <label class="col-form-label-sm">{{this.getLanguage["AFF"]["BN"]}}<span class="required" /> :</label>
                                                    <customtreeselect :multiple="false"
                                                                      :options="dd_agentgroup"
                                                                      :flat="true"
                                                                      :defaultExpandLevel="Infinity"
                                                                      :clearable="false"
                                                                      :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                                      v-model="obj_aaff['AGIT']"
                                                                      @input="AgentGroupChange"
                                                                      :disabled="obj_aaff.I > 0"
                                                                      v-if="getUserInfo.AT !== 4"
                                                                      ref="AGIT" />
                                                    <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BN') }}</span>
                                                </CCol>

                                                <CCol col="6" v-if="this.obj_aaff.AGT != 0 && this.obj_aaff.AT != 3">
                                                    <label class="col-form-label-sm">{{this.getLanguage["AFF"]["MAM"]}}<span class="required" /> :</label>
                                                    <treeselect :multiple="false"
                                                                :options="dd_memcount"
                                                                :placeholder="getLanguage['AFF']['MAM']"
                                                                :clearable="false"
                                                                v-model="obj_aaff['MAM']" />
                                                    <span class="ErrMsg">{{ ValidationErrMsg('MAM','MAM') }}</span>
                                                </CCol>
                                                <CCol col="6" v-else>
                                                </CCol>

                                                <CCol col="6" v-if="this.obj_aaff.AGT == 0 && this.obj_aaff.AT != 3">
                                                    <label class="col-form-label-sm">{{this.getLanguage["AFF"]["TEMP"]}}<span class="required" /> :</label>
                                                    <treeselect :multiple="false"
                                                                :options="dd_temp"
                                                                :placeholder="getLanguage['AFF']['TEMP']"
                                                                :clearable="false"
                                                                v-model="obj_aaff['IT']" />
                                                    <span class="ErrMsg">{{ ValidationErrMsg('IT','TEMP') }}</span>
                                                </CCol>

                                                <CCol col="6">
                                                    <label class="col-form-label-sm">
                                                        {{this.getLanguage["AFF"]["AT"]}}<span class="required" /> :

                                                        <div class="custom-tooltip">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2">{{getLanguage["AFF"]["USM"]}}</span>
                                                        </div>
                                                    </label>
                                                    <treeselect :multiple="false"
                                                                :options="dd_pm"
                                                                :placeholder="getLanguage['AFF']['AT']"
                                                                :disabled="obj_aaff.I > 0"
                                                                :clearable="false"
                                                                @input="ATChange"
                                                                v-model="obj_aaff['AT']"
                                                                :disable-branch-nodes="true"
                                                                :default-expand-level="1"
                                                                ref="AT" />
                                                    <span class="ErrMsg">{{ ValidationErrMsg('AT','AT') }}</span>
                                                </CCol>
                                                <CCol col="6" v-if="this.obj_aaff.AGT != 0">
                                                    <label class="col-form-label-sm">{{this.getLanguage["AFF"]["C"]}}<span class="required" /> :</label>
                                                    <treeselect :multiple="false"
                                                                :options="dd_currency"
                                                                :placeholder="getLanguage['AFF']['CI']"
                                                                :disabled="obj_aaff.I > 0"
                                                                :clearable="false"
                                                                v-model="obj_aaff['CI']"
                                                                @input="CurrencyChange"
                                                                ref="CI" />
                                                    <span class="ErrMsg">{{ ValidationErrMsg('CI','C') }}</span>
                                                </CCol>

                                                <CCol col="6" v-if="this.obj_aaff.AGT != 0 && this.obj_aaff.AT != 3">
                                                    <label class="col-form-label-sm">{{this.getLanguage["AFF"]["REFPYT"]}}<span class="required" /> :</label>
                                                    <treeselect :multiple="false"
                                                                :options="dd_AffiliatePayoutOption"
                                                                :placeholder="getLanguage['PM']['DT']"
                                                                :clearable="false"
                                                                :disabled="obj_aaff.I > 0"
                                                                v-model="obj_aaff['IWLY']" />
                                                    <span class="ErrMsg">{{ ValidationErrMsg('IWLY','TEMP') }}</span>
                                                </CCol>

                                                <!--Payout Type-->
                                                <template v-if="this.obj_aaff.AT == 3">
                                                    <CCol col="6">
                                                        <label class="col-form-label-sm">{{this.getLanguage["AFF"]["PT"]}}<span class="required" /> :</label>
                                                        <treeselect :multiple="false"
                                                                    :options="dd_payoutType"
                                                                    :placeholder="getLanguage['AFF']['PT']"
                                                                    :disabled="obj_aaff.I > 0"
                                                                    :clearable="false"
                                                                    v-model="obj_aaff['PT']"
                                                                    @input="payoutTypeChange"
                                                                    ref="PT" />
                                                        <span class="ErrMsg">{{ ValidationErrMsg('PT','PT') }}</span>
                                                    </CCol>
                                                    <CCol col="6" v-if="this.obj_aaff.PT == 0">
                                                        <label class="col-form-label-sm">{{this.getLanguage["AFF"]["PBT"]}}<span class="required" /> :</label>
                                                        <treeselect :multiple="false"
                                                                    :options="dd_payoutBonusType"
                                                                    :placeholder="getLanguage['AFF']['PBT']"
                                                                    :disabled="obj_aaff.I > 0"
                                                                    :clearable="false"
                                                                    v-model="obj_aaff['PBT']"
                                                                    ref="PBT" />
                                                        <span class="ErrMsg">{{ ValidationErrMsg('PBT','PBT') }}</span>
                                                    </CCol>
                                                </template>
                                            </CRow>

                                            <div class="my-2 d-flex" v-if="this.obj_aaff.AT != 3 && this.obj_aaff.AT != null && checkModuleAccess3(constAccessType.edit)">
                                                <input type="checkbox" id="IMT" v-model="obj_aaff.IMT" @change="checkEnableMultiTier" />
                                                <label class='searchLabel ml-2' for="IMT">{{this.getLanguage["AFF"]["EML"]}} </label>
                                            </div>
                                        </CCol>

                                        <CCol md="7" v-if="this.obj_aaff.AT != null && this.obj_aaff.AT != 3">
                                            <CCard>
                                                <CCardHeader>
                                                    <Strong>{{this.getLanguage["AFF"]["AFFTS"]}}</Strong>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CRow>
                                                        <CCol col="3">{{this.getLanguage["AFF"]["ACT"]}}<span class="required" /></CCol>
                                                        <CCol col="2">{{this.getLanguage["AFF"]["T"]}}<span class="required" /></CCol>
                                                        <CCol col="7">{{this.getLanguage["AFF"]["THS"]}}<span class="required" /></CCol>
                                                    </CRow>
                                                    <CRow v-for="(setup, index) in obj_aaff.ATYS" :key="'setup' + index">
                                                        <CCol col="3">
                                                            <input v-if="index == 0" type="checkbox" @click="defaultThreshold(index)" :checked="setup.RS" @change="v => setup.RS = v.target.checked"
                                                                   :disabled="obj_aaff.AGT == 0" />
                                                            <input v-else type="checkbox" :checked="setup.RS" @click="defaultThreshold(index)" @change="v => setup.RS = v.target.checked"
                                                                   :disabled="!obj_aaff.ATYS[index-1].RS || obj_aaff.AGT == 0" />
                                                        </CCol>
                                                        <CCol col="2">
                                                            {{ setup.T }}
                                                        </CCol>
                                                        <CCol col="7">
                                                            <div style="display:grid;grid-template-columns:1fr 15px 1fr">
                                                                <div>
                                                                    <CInput :prepend="currencySymbol" v-if="index == 0" size="sm" :value="ThousandSeparator(0, getThousandCurrency ? 3 : 2)" disabled />
                                                                    <CInput :prepend="currencySymbol" v-else size="sm" :value="ThousandSeparator(parseInt(obj_aaff.ATYS[index-1].TS) + 0.01, getThousandCurrency ? 3 : 2)" disabled />
                                                                </div>
                                                                <div class="text-center">
                                                                    -
                                                                </div>
                                                                <div>
                                                                    <CInput :prepend="currencySymbol" size="sm" :value="ThousandSeparator(setup.TS, getThousandCurrency ? 3 : 2)" @change="v => setup.TS = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"
                                                                            :disabled="!setup.RS || obj_aaff.AGT == 0" />
                                                                </div>
                                                            </div>
                                                        </CCol>
                                                    </CRow>
                                                    <CRow>
                                                        <CCol>
                                                            <span class="ErrMsg inline inline50">{{ ValidationErrMsg('ATSV','AFFTS') }}</span>
                                                        </CCol>
                                                    </CRow>
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                        <CCol md="7" v-if="this.obj_aaff.AT == 3">
                                            <CCard>
                                                <CCardHeader>
                                                    <Strong>{{this.getLanguage["AFF"]["AFFTS"]}}</Strong>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CRow>
                                                        <!--<CCol col="2">{{this.getLanguage["AFF"]["ACT"]}}<span class="required" /></CCol>
                                                        <CCol col="2">{{this.getLanguage["AFF"]["T"]}}<span class="required" /></CCol>-->
                                                        <CCol col="3">{{this.getLanguage["AFF"]["MDA"]}}<span class="required" /></CCol>
                                                        <CCol col="3" v-if="this.obj_aaff.PT == 0">{{this.getLanguage["AFF"]["MXD"]}}<span class="required" /></CCol>
                                                        <template v-if="this.obj_aaff.PBT == 1">
                                                            <CCol col="3">
                                                                {{this.getLanguage["AFF"]["PP"]}}
                                                                <span class="required" />
                                                            </CCol>
                                                        </template>
                                                        <template v-else>
                                                            <CCol col="3">
                                                                {{this.getLanguage["TNMT"]["APA"]}}
                                                                <span class="required" />
                                                            </CCol>
                                                        </template>
                                                        <CCol col="3" v-if="this.obj_aaff.PBT == 1">
                                                            {{this.getLanguage["AFF"]["MP"]}}<span class="required" />
                                                        </CCol>
                                                    </CRow>
                                                    <!--<CRow v-for="(setup, index) in obj_aaff.ATYS" :key="'setup' + index">-->
                                                    <CRow >
                                                        <!--<CCol col="2">
                                                            <input v-if="index == 0" type="checkbox" @click="defaultDeposit(index)" :checked="setup.RS" @change="v => setup.RS = v.target.checked"
                                                                   :disabled="obj_aaff.AGT == 0" />
                                                            <input v-else type="checkbox" :checked="setup.RS" @click="defaultDeposit(index)" @change="v => setup.RS = v.target.checked"
                                                                   :disabled="!obj_aaff.ATYS[index-1].RS || obj_aaff.AGT == 0" />
                                                        </CCol>
                                                        <CCol col="2">
                                                            {{ index }}
                                                        </CCol>-->
                                                        <CCol col="3">
                                                            <CInput :prepend="currencySymbol" size="sm" :value="ThousandSeparator(obj_aaff.MDA, getThousandCurrency ? 3 : 2)" @change="v => obj_aaff.MDA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" />
                                                            <span class="ErrMsg inline inline50">{{ ValidationErrMsg('MDA','MDA') }}</span>
                                                        </CCol>
                                                        <CCol col="3" v-if="this.obj_aaff.PT == 0">
                                                            <CInput :prepend="currencySymbol" size="sm" :value="ThousandSeparator(obj_aaff.MXDA, getThousandCurrency ? 3 : 2)" @change="v => obj_aaff.MXDA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" />
                                                            <span class="ErrMsg inline inline50">{{ ValidationErrMsg('MXDA','MXD') }}</span>
                                                        </CCol>
                                                        <template v-if="this.obj_aaff.PBT == 1">
                                                            <CCol col="3">
                                                                <CInput :append="'%'" size="sm" :value="ThousandSeparator(obj_aaff.PP, getThousandCurrency ? 2 : 2)" @change="v => obj_aaff.PP = RemoveThousandSeparator(v, getThousandCurrency ? 2 : 2)" />
                                                                <span class="ErrMsg inline inline50">{{ ValidationErrMsg('PP','PP') }}</span>
                                                            </CCol>
                                                        </template>
                                                        <template v-else>
                                                            <CCol col="3">
                                                                <CInput :prepend="currencySymbol" size="sm" :value="ThousandSeparator(obj_aaff.RBA, getThousandCurrency ? 3 : 2)" @change="v => obj_aaff.RBA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" />
                                                                <span class="ErrMsg inline inline50">{{ ValidationErrMsg('RBA','RBA') }}</span>
                                                            </CCol>
                                                        </template>
                                                        <CCol col="3" v-if="this.obj_aaff.PBT == 1">
                                                            <CInput :prepend="currencySymbol" size="sm" :value="ThousandSeparator(obj_aaff.MPA, getThousandCurrency ? 3 : 2)" @change="v => obj_aaff.MPA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" />
                                                            <span class="ErrMsg inline inline50">{{ ValidationErrMsg('MPA','MP') }}</span>
                                                        </CCol>
                                                    </CRow>
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                    <br>
                                    <CRow v-if="this.obj_aaff.AGT != 0 && this.obj_aaff.AGIT != null">
                                        <CCol>
                                            <CCard>
                                                <CCardHeader @click="visible = !visible" style="cursor:pointer">
                                                    <Strong>{{this.getLanguage["AFF"]["R"]}}</Strong>
                                                    <div class="fa-pull-right">
                                                        <span v-if="visible">{{this.getLanguage["BTN"]["HD"]}}</span>
                                                        <span v-else>{{this.getLanguage["BTN"]["V"]}}</span>
                                                    </div>
                                                </CCardHeader>
                                                <CCardBody v-if="visible">
                                                    <CRow>
                                                        <CCol col="6" v-for="(data, index) in dd_language" :key="'data' + index">
                                                            <label class="col-form-label-sm">{{data.label}} :</label>
                                                            <textarea rows="4" class="form-control form-control-sm" v-model="array_tnc[data.id]" v-shortkey.avoid />
                                                        </CCol>
                                                    </CRow>
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                    <br />
                                    <CRow v-if="this.obj_aaff.AGIT != null && this.obj_aaff.AT != null && this.obj_aaff.AT != 3">
                                        <CCol>
                                            <CCard>
                                                <CCardHeader style="display: flex;">
                                                    <CRow>
                                                        <CCol md="10">
                                                            <Strong>{{this.getLanguage["AFF"]["AFFTS"]}}</Strong>
                                                        </CCol>
                                                        <CCol md="2" v-if="this.obj_aaff.AGT != 0">
                                                            <treeselect :multiple="false"
                                                                        :options="dd_temp"
                                                                        :placeholder="getLanguage['AFF']['TEMP']"
                                                                        :clearable="false"
                                                                        v-model="obj_aaff['WT']"
                                                                        :disabled="obj_aaff.AT==null"
                                                                        @input="tempChange" />
                                                            <span class="ErrMsg">{{ ValidationErrMsg('WT','TEMP') }}</span>
                                                        </CCol>
                                                    </CRow>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CCol class="pl-0">
                                                        <span class="ErrMsg inline inline50">{{ ValidationErrMsg('ATSGC','AFFTS') }}</span>
                                                    </CCol>
                                                    <table class="custom-table custom-table-inPopUp inPopUp-IL afb-blue">
                                                        <thead>
                                                            <tr>
                                                                <th style="width: 10%;">{{this.getLanguage["AFF"]["ACT"]}}</th>
                                                                <th style="width: 15%;">{{this.getLanguage['AFF']['GC']}}</th>
                                                                <th style="width: 15%;">{{this.getLanguage['MR']['T']}} 1 (%)</th>
                                                                <th style="width: 15%;">{{this.getLanguage['MR']['T']}} 2 (%)</th>
                                                                <th style="width: 15%;">{{this.getLanguage['MR']['T']}} 3 (%)</th>
                                                                <th style="width: 15%;">{{this.getLanguage['MR']['T']}} 4 (%)</th>
                                                                <th style="width: 15%;">{{this.getLanguage['MR']['T']}} 5 (%)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(setting,index) in obj_aaff.AS" :key="setting.GCN">
                                                                <td>
                                                                    <label class="switch">
                                                                        <input type="checkbox" v-model="setting.RS" :disabled="obj_aaff.AGT == 0" @change="checkGameTiering(index)">
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                </td>
                                                                <td>
                                                                    {{ renderCategory(setting.GCI) }}

                                                                    <div v-if="obj_aaff.IMT" class="float-left mr-1 pointer" @click='editMultiTiering(setting,index)'>
                                                                        <i class="cil-color-border"></i>

                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || (obj_aaff.WT == 4)">
                                                                        <range-slider class="slider"
                                                                                        :min="0.1"
                                                                                        :max="3"
                                                                                        :step="0.1"
                                                                                        :value="ThousandSeparator(setting.T1,3)"
                                                                                        @change="v => setting.T1 = RemoveThousandSeparator(v,3)">
                                                                        </range-slider>
                                                                        <CInput size="sm" :value="ThousandSeparator(setting.T1,3)" @change="v => setting.T1 = RemoveThousandSeparator(v,3)" />
                                                                    </span>
                                                                    <span v-else>{{ setting.T1 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || (obj_aaff.WT == 4)">
                                                                        <range-slider class="slider"
                                                                                        :min="0.1"
                                                                                        :max="3"
                                                                                        :step="0.1"
                                                                                        :value="ThousandSeparator(setting.T2,3)"
                                                                                        @change="v => setting.T2 = RemoveThousandSeparator(v,3)">
                                                                        </range-slider>
                                                                        <CInput size="sm" :value="ThousandSeparator(setting.T2,3)" @change="v => setting.T2 = RemoveThousandSeparator(v,3)" />
                                                                    </span>
                                                                    <span v-else>{{ setting.T2 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || (obj_aaff.WT == 4)">
                                                                        <range-slider class="slider"
                                                                                        :min="0.1"
                                                                                        :max="3"
                                                                                        :step="0.1"
                                                                                        :value="ThousandSeparator(setting.T3,3)"
                                                                                        @change="v => setting.T3 = RemoveThousandSeparator(v,3)">
                                                                        </range-slider>
                                                                        <CInput size="sm" :value="ThousandSeparator(setting.T3,3)" @change="v => setting.T3 = RemoveThousandSeparator(v,3)" />
                                                                    </span>
                                                                    <span v-else>{{ setting.T3 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || (obj_aaff.WT == 4)">
                                                                        <range-slider class="slider"
                                                                                        :min="0.1"
                                                                                        :max="3"
                                                                                        :step="0.1"
                                                                                        :value="ThousandSeparator(setting.T4,3)"
                                                                                        @change="v => setting.T4 = RemoveThousandSeparator(v,3)">
                                                                        </range-slider>
                                                                        <CInput size="sm" :value="ThousandSeparator(setting.T4,3)" @change="v => setting.T4 = RemoveThousandSeparator(v,3)" />
                                                                    </span>
                                                                    <span v-else>{{ setting.T4 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || (obj_aaff.WT == 4)">
                                                                        <range-slider class="slider"
                                                                                        :min="0.1"
                                                                                        :max="3"
                                                                                        :step="0.1"
                                                                                        :value="ThousandSeparator(setting.T5,3)"
                                                                                        @change="v => setting.T5 = RemoveThousandSeparator(v,3)">
                                                                            <!-- !setting.RS || !obj_aaff.ATYS[4].RS -->
                                                                        </range-slider>
                                                                        <CInput size="sm" :value="ThousandSeparator(setting.T5,3)" @change="v => setting.T5 = RemoveThousandSeparator(v,3)" />
                                                                    </span>
                                                                    <span v-else>{{ setting.T5 }} %</span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px" v-if="bool_showSaveBtn && (checkModuleAccess2(constAccessType.add) || checkModuleAccess2(constAccessType.edit))">
                                    <CButton color="outline-info" size="sm" @click="saveAFF()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isMultiTiering">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow v-if="this.obj_aaff.AGIT != null && this.obj_aaff.AT != null && this.obj_aaff.AT != 3">
                                    <CCol>
                                        <CCard>
                                            <CCardHeader>
                                                <CRow class="align-items-center">
                                                    <CCol md="10">
                                                        <Strong>{{this.getLanguage["AFF"]["AFFMTS"]}}</Strong>
                                                    </CCol>
                                                    <CCol md="2">
                                                        <CButton id="btn-close1" class="float-right"
                                                                 @click="closeMultiTiering()">
                                                            <CIcon name=cilX></CIcon>
                                                        </CButton>
                                                    </CCol>
                                                </CRow>
                                            </CCardHeader>
                                            <CCardBody>
                                                <CRow>
                                                    <CCol v-if="obj_aaff.AT != 4" class="form-group">
                                                        <label class="col-form-label-sm">{{this.getLanguage["AG"]["GP"]}}<span class="required" /> :</label>
                                                        <treeselect :multiple="true"
                                                                    :limit="1"
                                                                    :options="dd_gameprovider"
                                                                    :defaultExpandLevel="2"
                                                                    valueConsistsOf="LEAF_PRIORITY"
                                                                    :placeholder="this.utilGetDDLanguage('AG.GP')"
                                                                    v-model="obj_aaffmt.GameProviderIds"
                                                                    ref="GPI" />
                                                    </CCol>
                                                </CRow>
                                                <!--<CRow>
                                                    <CCol v-if="obj_aaffmt.GCI != 5 &&  obj_aaff.AT != 4" class="form-group">
                                                        <label class="col-form-label-sm">{{this.getLanguage['AFF']['MPL']}}: {{this.gamesMaxLimit}}%</label>
                                                    </CCol>
                                                    <CCol v-if="obj_aaffmt.GCI != 5 &&  obj_aaff.AT == 4" class="form-group">
                                                        <label class="col-form-label-sm">{{this.getLanguage['AFF']['MPL']}}: {{this.allMaxLimit}}%</label>
                                                    </CCol>
                                                    <CCol v-if="obj_aaffmt.GCI == 5" class="form-group">
                                                        <label class="col-form-label-sm">{{this.getLanguage['AFF']['MPL']}}: {{this.slotMaxLimit}}%</label>
                                                    </CCol>
                                                </CRow>-->
                                                <CRow style="padding: 10px 15px 30px; display: block;">
                                                    <!--<CCol class="pl-0">
                                                        <span class="ErrMsg inline inline50">{{ ValidationErrMsg('ATSGC','AFFTS') }}</span>
                                                    </CCol>-->
                                                    <table class="custom-table custom-table-inPopUp afb-blue">
                                                        <thead>
                                                            <tr>
                                                                <th style="width: 15%;">{{this.getLanguage['AFF']['THS']}} {{this.getLanguage['AFF']['T']}} </th>
                                                                <th style="width: 15%;">{{this.getLanguage['AFF']['CPCT']}}<div class="custom-tooltip mx-1"><i class="fa fa-question-circle"></i><span class="custom-tooltiptext2 affilliate-type">{{getLanguage["AFF"]["CPTT"]}}</span></div></th>
                                                                <th style="width: 15%;">{{this.getLanguage['AFF']['DLL']}} 1 </th>
                                                                <th style="width: 15%;">{{this.getLanguage['AFF']['DLL']}} 2 </th>
                                                                <th style="width: 15%;">{{this.getLanguage['AFF']['DLL']}} 3 </th>
                                                                <th style="width: 15%;">{{this.getLanguage['AFF']['DLL']}} 4 </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    1
                                                                </td>
                                                                <td>
                                                                    <!--<span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <CInput size="sm" :value="CalculateCPCT(obj_aaffmt.T1,getThousandCurrency ? 3 : 2)" @change="v => obj_aaffmt.T1 = RemoveThousandSeparator(v,3)" />
                                                                    </span>-->
                                                                    <span>{{ ThousandSeparator(obj_aaffmt.T1,3) }} %</span>
                                                                    <!--<span v-if="(obj_aaff.AGT == 0 || obj_aaff.WT == 4) && obj_aaffmt.GCI == 5" :class="obj_aaffmt.T1 > slotMaxLimit? 'negative-number': 'positive-number'">{{ CalculateCPCT( 1,obj_aaffmt.T1,getThousandCurrency ? 3 : 2 ) }}</span>
                                                                    <span v-else-if="(obj_aaff.AGT == 0 || obj_aaff.WT == 4) && obj_aaffmt.GCI != 5 && obj_aaff.AT == 4" :class="obj_aaffmt.T1 > allMaxLimit? 'negative-number': 'positive-number'">{{ CalculateCPCT( 1,obj_aaffmt.T1,getThousandCurrency ? 3 : 2 ) }}</span>
                                                                    <span v-else-if="(obj_aaff.AGT == 0 || obj_aaff.WT == 4) && obj_aaffmt.GCI != 5 &&  obj_aaff.AT != 4" :class="obj_aaffmt.T1 > gamesMaxLimit? 'negative-number': 'positive-number'">{{ CalculateCPCT( 1,obj_aaffmt.T1,getThousandCurrency ? 3 : 2 ) }}</span>
                                                                    <span v-else>{{ obj_aaffmt.T1 }} %</span>-->

                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T1DL1,3)" @change="v => obj_aaffmt.T1DL1 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T1DL1" @change="TextValueChange('T1DL1',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T1DL1 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T1DL2,3)" @change="v => obj_aaffmt.T1DL2 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T1DL2" @change="TextValueChange('T1DL2',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T1DL2 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T1DL3,3)" @change="v => obj_aaffmt.T1DL3 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T1DL3" @change="TextValueChange('T1DL3',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T1DL3 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T1DL4,3)" @change="v => obj_aaffmt.T1DL4 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T1DL4" @change="TextValueChange('T1DL4',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T1DL4 }} %</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    2
                                                                </td>
                                                                <td>
                                                                    <span>{{ ThousandSeparator(obj_aaffmt.T2,3) }} %</span>
                                                                    <!--<span v-if="(obj_aaff.AGT == 0 || obj_aaff.WT == 4) && obj_aaffmt.GCI == 5" :class="obj_aaffmt.T2 > slotMaxLimit? 'negative-number': 'positive-number'">{{ CalculateCPCT( 2,obj_aaffmt.T2,getThousandCurrency ? 3 : 2 ) }}</span>
                                                                    <span v-else-if="(obj_aaff.AGT == 0 || obj_aaff.WT == 4) && obj_aaffmt.GCI != 5 && obj_aaff.AT == 4" :class="obj_aaffmt.T2 > allMaxLimit? 'negative-number': 'positive-number'">{{ CalculateCPCT( 2,obj_aaffmt.T2,getThousandCurrency ? 3 : 2 ) }}</span>
                                                                    <span v-else-if="(obj_aaff.AGT == 0 || obj_aaff.WT == 4) && obj_aaffmt.GCI != 5 &&  obj_aaff.AT != 4" :class="obj_aaffmt.T2 > gamesMaxLimit? 'negative-number': 'positive-number'">{{ CalculateCPCT( 2,obj_aaffmt.T2,getThousandCurrency ? 3 : 2 ) }}</span>
                                                                    <span v-else>{{ obj_aaffmt.T2 }} %</span>-->
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T2DL1,3)" @change="v => obj_aaffmt.T2DL1 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T2DL1" @change="TextValueChange('T2DL1',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T2DL1 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T2DL2,3)" @change="v => obj_aaffmt.T2DL2 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T2DL2" @change="TextValueChange('T2DL2',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T2DL2 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T2DL3,3)" @change="v => obj_aaffmt.T2DL3 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T2DL3" @change="TextValueChange('T2DL3',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T2DL3 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T2DL4,3)" @change="v => obj_aaffmt.T2DL4 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T2DL4" @change="TextValueChange('T2DL4',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T2DL4 }} %</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    3
                                                                </td>
                                                                <td>
                                                                    <span>{{ ThousandSeparator(obj_aaffmt.T3,3) }} %</span>
                                                                    <!--<span v-if="(obj_aaff.AGT == 0 || obj_aaff.WT == 4) && obj_aaffmt.GCI == 5" :class="obj_aaffmt.T3 > slotMaxLimit? 'negative-number': 'positive-number'">{{ CalculateCPCT( 3,obj_aaffmt.T3,getThousandCurrency ? 3 : 2 ) }}</span>
                                                                    <span v-else-if="(obj_aaff.AGT == 0 || obj_aaff.WT == 4) && obj_aaffmt.GCI != 5 && obj_aaff.AT == 4" :class="obj_aaffmt.T3 > allMaxLimit? 'negative-number': 'positive-number'">{{ CalculateCPCT( 3,obj_aaffmt.T3,getThousandCurrency ? 3 : 2 ) }}</span>
                                                                    <span v-else-if="(obj_aaff.AGT == 0 || obj_aaff.WT == 4) && obj_aaffmt.GCI != 5 &&  obj_aaff.AT != 4" :class="obj_aaffmt.T3 > gamesMaxLimit? 'negative-number': 'positive-number'">{{ CalculateCPCT( 3,obj_aaffmt.T3,getThousandCurrency ? 3 : 2 ) }}</span>
                                                                    <span v-else>{{ obj_aaffmt.T3 }} %</span>-->
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T3DL1,3)" @change="v => obj_aaffmt.T3DL1 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T3DL1" @change="TextValueChange('T3DL1',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T3DL1 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T3DL2,3)" @change="v => obj_aaffmt.T3DL2 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T3DL2" @change="TextValueChange('T3DL2',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T3DL2 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T3DL3,3)" @change="v => obj_aaffmt.T3DL3 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T3DL3" @change="TextValueChange('T3DL3',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T3DL3 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T3DL4,3)" @change="v => obj_aaffmt.T3DL4 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T3DL4" @change="TextValueChange('T3DL4',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T3DL4 }} %</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    4
                                                                </td>
                                                                <td>
                                                                    <span>{{ ThousandSeparator(obj_aaffmt.T4,3) }} %</span>
                                                                    <!--<span v-if="(obj_aaff.AGT == 0 || obj_aaff.WT == 4) && obj_aaffmt.GCI == 5" :class="obj_aaffmt.T4 > slotMaxLimit? 'negative-number': 'positive-number'">{{ CalculateCPCT( 4,obj_aaffmt.T4,getThousandCurrency ? 3 : 2 ) }}</span>
                                                                    <span v-else-if="(obj_aaff.AGT == 0 || obj_aaff.WT == 4) && obj_aaffmt.GCI != 5 && obj_aaff.AT == 4" :class="obj_aaffmt.T4 > allMaxLimit? 'negative-number': 'positive-number'">{{ CalculateCPCT( 4,obj_aaffmt.T4,getThousandCurrency ? 3 : 2 ) }}</span>
                                                                    <span v-else-if="(obj_aaff.AGT == 0 || obj_aaff.WT == 4) && obj_aaffmt.GCI != 5 &&  obj_aaff.AT != 4" :class="obj_aaffmt.T4 > gamesMaxLimit? 'negative-number': 'positive-number'">{{ CalculateCPCT( 4,obj_aaffmt.T4,getThousandCurrency ? 3 : 2 ) }}</span>
                                                                    <span v-else>{{ obj_aaffmt.T4 }} %</span>-->
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T4DL1,3)" @change="v => obj_aaffmt.T4DL1 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T4DL1" @change="TextValueChange('T4DL1',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T4DL1 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T4DL2,3)" @change="v => obj_aaffmt.T4DL2 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T4DL2" @change="TextValueChange('T4DL2',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T4DL2 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T4DL3,3)" @change="v => obj_aaffmt.T4DL3 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T4DL3" @change="TextValueChange('T4DL3',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T4DL3 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T4DL4,3)" @change="v => obj_aaffmt.T4DL4 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T4DL4" @change="TextValueChange('T4DL4',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T4DL4 }} %</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    5
                                                                </td>
                                                                <td>
                                                                    <span>{{ ThousandSeparator(obj_aaffmt.T5,3) }} %</span>
                                                                    <!--<span v-if="(obj_aaff.AGT == 0 || obj_aaff.WT == 4) && obj_aaffmt.GCI == 5" :class="obj_aaffmt.T5 > slotMaxLimit? 'negative-number': 'positive-number'">{{ CalculateCPCT( 5,obj_aaffmt.T5,getThousandCurrency ? 3 : 2 ) }}</span>
                                                                    <span v-else-if="(obj_aaff.AGT == 0 || obj_aaff.WT == 4) && obj_aaffmt.GCI != 5 && obj_aaff.AT == 4" :class="obj_aaffmt.T5 > allMaxLimit? 'negative-number': 'positive-number'">{{ CalculateCPCT( 5,obj_aaffmt.T5,getThousandCurrency ? 3 : 2 ) }}</span>
                                                                    <span v-else-if="(obj_aaff.AGT == 0 || obj_aaff.WT == 4) && obj_aaffmt.GCI != 5 &&  obj_aaff.AT != 4" :class="obj_aaffmt.T5 > gamesMaxLimit? 'negative-number': 'positive-number'">{{ CalculateCPCT( 5,obj_aaffmt.T5,getThousandCurrency ? 3 : 2 ) }}</span>
                                                                    <span v-else>{{ obj_aaffmt.T5 }} %</span>-->
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T5DL1,3)" @change="v => obj_aaffmt.T5DL1 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T5DL1" @change="TextValueChange('T5DL1',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T5DL1 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T5DL2,3)" @change="v => obj_aaffmt.T5DL2 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T5DL2" @change="TextValueChange('T5DL2',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T5DL2 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T5DL3,3)" @change="v => obj_aaffmt.T5DL3 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T5DL3" @change="TextValueChange('T5DL3',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T5DL3 }} %</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="obj_aaff.AGT == 0 || obj_aaff.WT == 4">
                                                                        <!--<CInput size="sm" :value="ThousandSeparator(obj_aaffmt.T5DL4,3)" @change="v => obj_aaffmt.T5DL4 = RemoveThousandSeparator(v,3)" />-->
                                                                        <textarea vertical="" rows="1" class="form-control form-control-sm" :value="obj_aaffmt.T5DL4" @change="TextValueChange('T5DL4',$event)" />
                                                                    </span>
                                                                    <span v-else>{{ obj_aaffmt.T5DL4 }} %</span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </CRow>
                                            </CCardBody>
                                        </CCard>
                                    </CCol>

                                </CRow>

                                <div style="text-align:center;margin-top:20px" v-if="bool_showMultiTierSaveBtn && (checkModuleAccess2(constAccessType.add) || checkModuleAccess2(constAccessType.edit))">
                                    <CButton color="outline-info" size="sm" @click="saveAFFMultiTier()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['NO']}}
                                            </template>
                                            <template v-else-if="header == 'GN' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete) || checkModuleAccess2(constAccessType.view))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["ACT"]}}
                                            </template>
                                            <template v-else-if="header == 'RS' && checkModuleAccess2(constAccessType.edit)">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["AFF"]["ACT"]}}
                                                <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'AGI'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["AFF"]["BN"]}}
                                                <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CI'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["AFF"]["C"]}}
                                                <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'EML'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["AFF"]["EML"]}}
                                                <i @click="setSortTable('IMT')" :class="setSortLogo('IMT')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'T'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["AFF"]["TEMP"]}}
                                                <i @click="setSortTable('TT')" :class="setSortLogo('TT')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'AT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["AFF"]["AT"]}}
                                                <div class="custom-tooltip mx-1"><i class="fa fa-question-circle"></i><span class="custom-tooltiptext2 affilliate-type" style=" width: 200px !important; left: 25px !important;">{{getLanguage["AFF"]["USM"]}}</span></div>
                                                <i @click="setSortTable('AT')" :class="setSortLogo('AT')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'R'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["AFF"]["R"]}}
                                            </template>
                                            <template v-else-if="header == 'CTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["CT"]}}
                                                <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["SMB"]["AFFS"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addAFF()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div v-if="getUserInfo.AT !== 4" class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AFF"]["BN"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroupfs"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="AgentGroupChangefs"
                                                  v-model="searchAgent" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AFF"]["AT"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_pm"
                                            :placeholder="this.utilGetDDLanguage('AFF.AT')"
                                            v-model="str_FV[1].FV"
                                            :disable-branch-nodes="true"
                                            :default-expand-level="1"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[2].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[2].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[2].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[2].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[2].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[2].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AFF"]["C"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_fullcurrency"
                                            :placeholder="this.utilGetDDLanguage('AFF.C')"
                                            v-model="str_FV[3].FV"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class='searchBtn' size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header" style="z-index:2;!important">
                    <strong>{{getLanguage['AFF']['AFF']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'GN' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete) || checkModuleAccess2(constAccessType.view))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'RS' && checkModuleAccess2(constAccessType.edit)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["AFF"]["ACT"]}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AGI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["AFF"]["BN"]}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["AFF"]["C"]}}
                                        <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'EML'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["AFF"]["EML"]}}
                                        <i @click="setSortTable('IMT')" :class="setSortLogo('IMT')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'T'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["AFF"]["TEMP"]}}
                                        <i @click="setSortTable('TT')" :class="setSortLogo('TT')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["AFF"]["AT"]}}
                                        <div class="custom-tooltip mx-1"><i class="fa fa-question-circle"></i><span class="custom-tooltiptext2 affilliate-type">{{getLanguage["AFF"]["USM"]}}</span></div>
                                        <i @click="setSortTable('ATV')" :class="setSortLogo('ATV')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'R'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["AFF"]["R"]}}
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["CT"]}}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'GN' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete) || checkModuleAccess2(constAccessType.view))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'RS' && checkModuleAccess2(constAccessType.edit)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["AFF"]["ACT"]}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AGI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["AFF"]["BN"]}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["AFF"]["C"]}}
                                        <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'EML'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["AFF"]["EML"]}}
                                        <i @click="setSortTable('IMT')" :class="setSortLogo('IMT')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'T'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["AFF"]["TEMP"]}}
                                        <i @click="setSortTable('TT')" :class="setSortLogo('TT')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["AFF"]["AT"]}}
                                        <div class="custom-tooltip mx-1"><i class="fa fa-question-circle"></i><span class="custom-tooltiptext2 affilliate-type">{{getLanguage["AFF"]["USM"]}}</span></div>
                                        <i @click="setSortTable('ATV')" :class="setSortLogo('ATV')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'R'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["AFF"]["R"]}}
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["CT"]}}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_aff.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_aff">
                            <td v-for="header in reportHeaders" :key="header">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'GN' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete) || checkModuleAccess2(constAccessType.view))">
                                    <span id="actionBtnCol">
                                        <div v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom-tooltip">
                                            <i class="cil-trash" @click="removeAFF(data)"></i>
                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div v-else-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)" class="custom-tooltip">
                                            <i class="cil-trash"></i>
                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom-tooltip">
                                            <i class="cil-color-border" @click="editAFF(data.I)"></i>
                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                        <div v-else-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)" class="custom-tooltip">
                                            <i class="cil-color-border"></i>
                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                        <div v-if="checkModuleAccess2(constAccessType.view) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom-tooltip">
                                            <i class="cil-description" @click="viewAFF(data.I)"></i> <!--here View -->
                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                        </div>
                                        <div v-else-if="checkModuleAccess2(constAccessType.view) && (isSENS == 1 && data.AGI != curAGI)" class="custom-tooltip">
                                            <i class="cil-description"></i> <!--here View -->
                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'RS' && checkModuleAccess2(constAccessType.edit)">
                                    <CCol col="4" v-if="data.IT == 0 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <label class="switch">
                                            <input type="checkbox" true-value="2" false-value="1" v-model="data.RS" @click="updateAFFStatus(data)">
                                            <span class="slider round"></span>
                                        </label>
                                    </CCol>
                                    <CCol col="4" v-else-if="data.IT == 0 && (isSENS == 1 && data.AGI != curAGI)">
                                        <label class="switch">
                                            <input type="checkbox" true-value="2" false-value="1" v-model="data.RS">
                                            <span class="slider round"></span>
                                        </label>
                                    </CCol>
                                    <CCol col="4" v-else>-</CCol>
                                </template>
                                <template v-else-if="header == 'AGI'">
                                    <span class="grid-line">{{ data.GN }} ({{ data.GPC }})</span>
                                </template>
                                <template v-else-if="header == 'CI'">
                                    <span v-if="data.IT == 0">{{ renderCurrency(data.ISOC) }}</span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'EML'">
                                    <span v-if="data.IMT == 1">{{getLanguage["AFF"]["YES"]}}</span>
                                    <span v-else>{{getLanguage["AFF"]["NO"]}}</span>
                                </template>
                                <template v-else-if="header == 'T'">
                                    <span>{{ renderTemplate(data.TT) }}</span>
                                </template>
                                <template v-else-if="header == 'AT'">
                                    <span>{{ renderPayoutMethod(data.ATV) }}</span>
                                    <span v-if="data.ATV != 4" class="grid-line">( {{ renderPayoutDuration(data.IWLY) }} )</span>
                                </template>
                                <template v-else-if="header == 'R'">
                                    <span v-if="data.IT == 0 && data.AT != 3">{{getLanguage["AFF"]["MAM"]}}: {{ data.MAM }}</span>
                                    <span v-else-if="data.IT == 0 && data.AT == 3">
                                        <span class="grid-line">{{ renderPayoutType(data.PT) }}</span>
                                        <span class="grid-line">{{getLanguage["AFF"]["MDA"]}}: {{ formatNumber(data.MDA, 2, data.CS) }}</span>
                                        <span v-if="data.PBT == 0" class="grid-line">{{getLanguage["AFF"]["RBA"]}}: {{ formatNumber(data.RBA, 2, data.CS) }}</span>
                                        <span v-else-if="data.PBT == 1" class="grid-line">{{getLanguage["AFF"]["RBA"]}}: {{ formatNumber(data.PP, 2) }}%</span>
                                    </span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'CTS'">
                                    {{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import RangeSlider from 'vue-range-slider'
    import 'vue-range-slider/dist/vue-range-slider.css'
    import Loading from 'vue-loading-overlay';
    import { required, requiredIf, decimal } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import { constAccessType, loadingFullScreen, constHouseBrand } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))
    import draggable from 'vuedraggable';

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            RangeSlider,
            draggable
        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_isMultiTiering: false,
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                bool_showSaveBtn: false,
                bool_showMultiTierSaveBtn: false,
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true,
                str_FV: [{ F: "AGI" }, { F: "AT_csv", FA: true }, {
                    F: "CTS", FV: {
                        startDate: "",
                        endDate: ""
                    }
                }, { F: "CI_csv", FA: true }], //Filter Value
                arry_aff: [],
                obj_aaff: {
                    I: 0,
                    RS: 1,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    ATYS: [],
                    AS: [],
                    CI: null,
                    AGIT: null,
                    MAM: 2,
                    AT: null,
                    AGT: 3,
                    IT: null,
                    WT: null,
                    R: "",
                    MDA: 0,
                    RBA: 1,
                    IMT: false,
                    PT: 0,
                    IWLY: 0,
                    PBT: 0,
                    MXDA: 0,
                    PP: 0,
                    MPA: 0
                },
                obj_aaffmt: {
                    I: 0,
                    RS: 1,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    ATYS: [],
                    AMS: [],
                    AS: [],
                    CI: null,
                    AGIT: null,
                    MAM: 2,
                    AT: null,
                    AGT: 3,
                    IT: null,
                    WT: null,
                    R: "",
                    MDA: 0,
                    RBA: 1,
                    GameProviderIds: [],
                    IWLY: 0
                },
                obj_af: [],
                dd_agentgroup: [],//agent group option
                dd_agentgroupfs: [],//agent group option
                dd_currency: [],
                dd_fullcurrency: [],
                ddCategoryList: [],
                ddCategoryALL: [],
                ddCategory: [],
                dd_AffiliatePayoutOption: [],
                dd_memcount: [],
                dd_pm: [],
                dd_view_pm: [],
                dd_language: [],
                dd_temp: [], // templete
                dd_payoutType: [],
                dd_payoutBonusType: [],
                constAccessType: constAccessType,
                array_tnc: [],
                visible: false,
                searchAgent: null,
                ATSV: null,
                ATSGC: null,
                dd_gameprovider_cat: [],
                dd_gameprovider: [],
                editMultiTierIndex: -1,
                defaultReportHeaders: ['NO', 'GN', 'RS', 'AGI', 'CI', 'EML', 'T', 'AT', 'R', 'CTS'],
                reportHeaders: [],
                needResetHeaders: false,
                sportbookMaxLimit: 0,
                livecasinoMaxLimit: 0,
                slotMaxLimit: 0,
                lotteryMaxLimit: 0,
                fishingMaxLimit: 0,
                ecasinoMaxLimit: 0,
                gamesMaxLimit: 0,
                racingMaxLimit: 0,
                isMaxLimitValid: true,
                bool_isDDMV: false,
                errormsg: "",
                currencySymbol: null,
            }
        },
        validations: {
            obj_aaff: {
                AGIT: { required },
                WT: {
                    required: requiredIf(function (vm) {
                        return this.obj_aaff.AGT != 0 && this.obj_aaff.AT != 3
                    }),
                },
                MAM: {
                    required: requiredIf(function (vm) {
                        return this.obj_aaff.AGT != 0 && this.obj_aaff.AGT != 3
                    }),
                },
                IWLY: { required },
                AT: { required },
                CI: {
                    required: requiredIf(function (vm) {
                        return this.obj_aaff.AGT != 0
                    }),
                },
                IT: {
                    required: requiredIf(function (vm) {
                        return this.obj_aaff.AGT == 0
                    }),
                },
                MDA: {
                    decimal,
                    required: requiredIf(function (vm) {
                        return this.obj_aaff.AGT == 3
                    }),
                },
                RBA: {
                    decimal,
                    required: requiredIf(function (vm) {
                        return this.obj_aaff.AGT == 3
                    }),
                },
                PT: {
                    required: requiredIf(function (vm) {
                        return this.obj_aaff.AGT == 3
                    }),
                },
                PBT: {
                    required: requiredIf(function (vm) {
                        return this.obj_aaff.AGT == 3
                    }),
                },
                PP: {
                    decimal,
                    required: requiredIf(function (vm) {
                        return this.obj_aaff.AGT == 3
                    }),
                },
                MPA: {
                    decimal,
                    required: requiredIf(function (vm) {
                        return this.obj_aaff.AGT == 3
                    }),
                },
                MXDA: {
                    decimal,
                    required: requiredIf(function (vm) {
                        return this.obj_aaff.AGT == 3
                    }),
                }
            },
            obj_aaffmt: {
                T1DL1: {
                    decimal
                }
            },
            ATSV: {
                required: requiredIf(function (vm) {
                    return this.obj_aaff.AT != 3 && this.obj_aaff.AGT != 0
                }),
            },
            ATSGC: {
                required: requiredIf(function (vm) {
                    return this.obj_aaff.AT != 3 && this.obj_aaff.AGT != 0
                }),
            }
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'AFF';
            this.$parent.showActiveMenu = 'AFF.AFFS';

            if (this.$route.query.agi) {
                this.searchAgent = this.$route.query.agi;
                var agi = this.$route.query.agi.split("-");
                this.str_FV[0].FV = agi[1];
            }
            this.getAFFList();
            this.getAgentGroup();
            this.getCurrencyList();
            this.getMemberCount();
            this.getDropdownList();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;

        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            //bool_isMultiTiering() {
            //    if (!this.bool_isMultiTiering && this.bool_CV) {
            //        this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
            //    }
            //}
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/AffiliateSetting`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else
                                    try {
                                        that.reportHeaders = JSON.parse(d);

                                        if (!that.checkModuleAccess2(constAccessType.edit)) {
                                            var myIndex = that.defaultReportHeaders.indexOf('RS');
                                            if (myIndex !== -1) {
                                                that.defaultReportHeaders.splice(myIndex, 1);
                                            }
                                            var myIndex = that.reportHeaders.indexOf('RS');
                                            if (myIndex !== -1) {
                                                that.reportHeaders.splice(myIndex, 1);
                                            }
                                        }

                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/AffiliateSetting/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            },
            getLanguage() {
                this.getAFFList();
                this.getDropdownList();                
            },
        },
        methods: {
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            CurrencyChange(value) {
                var that = this;
                this.dd_currency.find(function (val, idx) {
                    if (val.id == value) {
                        that.setThousandCurrency(that.CheckIsThousandCurrency(val.label, that), that);
                        that.currencySymbol = val.label;
                    }
                });
            },
            payoutTypeChange(value) {
                if (value = 1) {
                    this.obj_aaff.PBT = 0;
                    this.obj_aaff.MXDA = 9999999;
                }
            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[3].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[3].FV.endDate = "";
                    }
                }
            },
            AgentGroupChange(value) {

                if (this.obj_aaff.I == 0) {
                    this.dd_currency = [];
                    this.dd_language = [];
                    this.obj_aaff.CI = null;
                }

                var that = this;
                var agi = 0;
                var at = -1;

                if (value != "") {
                    agi = value.split("-")[1];
                    at = value.split("-")[0];
                }

                if (at == 0) {
                    this.obj_aaff.AGT = at;
                    this.obj_aaff.MAM = 0;
                    this.LoopAffiliateSetup(true, this.obj_aaff.I, this.obj_aaff.AT);
                }
                else {
                    this.obj_aaff.AGT = at;
                    if (this.obj_aaff.I == 0) {
                        this.obj_aaff.MAM = 2;
                    }
                    this.obj_aaff.IT = null;

                    this.LoopAffiliateSetup(false, this.obj_aaff.I, this.obj_aaff.AT);
                }

                this.getDataApi('/api/dd/cur/' + agi,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                            if (that.obj_aaff.CI > 0) {
                                that.CurrencyChange(that.obj_aaff.CI);
                            }
                        }
                    });

                this.getDataApi('/api/dd/lang/' + agi,
                    function (d, s) {
                        if (s) {
                            that.dd_language = d.dropdownlist;                            
                        }
                    });
            },
            LoopAffiliateSetup(isSuperAdmin, isEdit, affiliateType = null) {

                if (affiliateType != null && affiliateType == 4) {
                    this.ddCategory = this.ddCategoryALL;
                }
                else {
                    this.ddCategory = this.ddCategoryList;
                }

                if (isSuperAdmin && isEdit == 0) {
                    var ATYS = [];
                    for (var i = 0; i < 5; i++) {
                        ATYS[i] = {
                            T: i + 1,
                            RS: true,
                            TS: 0,
                        };
                    }
                    this.$set(this.$data.obj_aaff, 'ATYS', ATYS);

                    var AS = [];

                    if (this.ddCategory.length > 0) {
                        if (this.obj_aaff.AT != null && this.obj_aaff.AT == 3) {
                            for (var i = 0; i < this.ddCategory.length; i++) {
                                AS[i] = {
                                    RS: false,
                                    T1: 0,
                                    T2: 0,
                                    T3: 0,
                                    T4: 0,
                                    T5: 0,
                                    GCI: this.ddCategory[i].id,
                                    GCN: this.ddCategory[i].label
                                };
                            }
                        }
                        else {
                            for (var i = 0; i < this.ddCategory.length; i++) {
                                AS[i] = {
                                    RS: true,
                                    T1: 0,
                                    T2: 0,
                                    T3: 0,
                                    T4: 0,
                                    T5: 0,
                                    GCI: this.ddCategory[i].id,
                                    GCN: this.ddCategory[i].label,
                                    ID: 0,
                                    T1DL1: 0,
                                    T1DL2: 0,
                                    T1DL3: 0,
                                    T1DL4: 0,
                                    T2DL1: 0,
                                    T2DL2: 0,
                                    T2DL3: 0,
                                    T2DL4: 0,
                                    T3DL1: 0,
                                    T3DL2: 0,
                                    T3DL3: 0,
                                    T3DL4: 0,
                                    T4DL1: 0,
                                    T4DL2: 0,
                                    T4DL3: 0,
                                    T4DL4: 0,
                                    T5DL1: 0,
                                    T5DL2: 0,
                                    T5DL3: 0,
                                    T5DL4: 0
                                    //GPI: []
                                };
                            }
                        }
                    }

                    this.$set(this.$data.obj_aaff, 'AS', AS);
                }
                else if (isEdit == 0) {
                    var ATYS = [];
                    for (var i = 0; i < 5; i++) {
                        ATYS[i] = {
                            T: i + 1,
                            RS: false,
                            TS: 0,
                        };
                    }

                    this.$set(this.$data.obj_aaff, 'ATYS', ATYS);

                    var AS = [];
                    if (this.ddCategory.length > 0) {
                        for (var i = 0; i < this.ddCategory.length; i++) {
                            AS[i] = {
                                RS: false,
                                T1: 0,
                                T2: 0,
                                T3: 0,
                                T4: 0,
                                T5: 0,
                                GCI: this.ddCategory[i].id,
                                GCN: this.ddCategory[i].label,
                                ID: 0,
                                T1DL1: 0,
                                T1DL2: 0,
                                T1DL3: 0,
                                T1DL4: 0,
                                T2DL1: 0,
                                T2DL2: 0,
                                T2DL3: 0,
                                T2DL4: 0,
                                T3DL1: 0,
                                T3DL2: 0,
                                T3DL3: 0,
                                T3DL4: 0,
                                T4DL1: 0,
                                T4DL2: 0,
                                T4DL3: 0,
                                T4DL4: 0,
                                T5DL1: 0,
                                T5DL2: 0,
                                T5DL3: 0,
                                T5DL4: 0
                                //GPI: []
                            };
                        }
                    }

                    this.$set(this.$data.obj_aaff, 'AS', AS);
                }

            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                        this.searchPAgi = agi;
                        this.str_FV[0].FV = this.searchPAgi;
                    } else {
                        this.searchPAgi = 0;
                    }
                } else {
                    this.searchPAgi = 0;
                    this.str_FV[0].FV = null;
                }
                this.str_FV[3].FV = null;
                this.dd_fullcurrency = null;
                this.getCurrencyList();
            },
            getCategory() {
                var that = this;
                this.getDataApi(`/api/dd/gameCat/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCategoryList = d.dropdownlist;
                            that.ddCategoryALL = [{ id: "0", label: that.getLanguage['GL']['ALL'] }];
                        }
                        else {
                            that.ddCategoryList = null;
                            that.ddCategoryALL = null;
                        }
                    });
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }

                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_fullcurrency = d.dropdownlist;
                        }
                    });
            },
            renderCurrency(ISOC) {
                if (ISOC && ISOC in this.getLanguage['DB'])
                    return this.getLanguage['DB'][ISOC];
                else
                    return ISOC;
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('AFFS', 'AFF', type);
            },
            checkModuleAccess3(type) {
                return this.checkModuleAccess('EML', 'AFF', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            closeMultiTiering() {
                this.bool_isMultiTiering = !this.bool_isMultiTiering;
                this.bool_CV = false;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getAFFList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getAFFList();
                }
            },
            getViewPMList() {
                this.dd_view_pm = [
                    {
                        id: -1,
                        label: this.getLanguage['AFF']['CAT'] + ' 1',
                        children: [
                            {
                                id: '1',
                                label: this.getLanguage['AFF']['PM1']
                            },
                            {
                                id: '2',
                                label: this.getLanguage['AFF']['PM2']
                            },
                            {
                                id: '3',
                                label: this.getLanguage['AFF']['PM4']
                            }
                        ]
                    },
                    {
                        id: '-2',
                        label: this.getLanguage['AFF']['CAT'] + ' 2',
                        children: [
                            {
                                id: '4',
                                label: this.getLanguage['AFF']['PM3']
                            }
                        ]
                    }
                ];
            },
            getPMList() {
                this.dd_pm = [
                    {
                        id: -1,
                        label: this.getLanguage['AFF']['CAT'] + ' 1',
                        children: [
                            {
                                id: '1',
                                label: this.getLanguage['AFF']['PM1']
                            },
                            {
                                id: '2',
                                label: this.getLanguage['AFF']['PM2']
                            },
                            {
                                id: '4',
                                label: this.getLanguage['AFF']['PM4']
                            }
                        ]
                    },
                    {
                        id: '-2',
                        label: this.getLanguage['AFF']['CAT'] + ' 2',
                        children: [
                            {
                                id: '3',
                                label: this.getLanguage['AFF']['PM3']
                            }
                        ]
                    }
                ];
            },
            getTEMPList() {
                this.dd_temp = [{ id: '1', label: this.getLanguage['AFF']['TEMP1'] }, { id: '2', label: this.getLanguage['AFF']['TEMP2'] },
                { id: '3', label: this.getLanguage['AFF']['TEMP3'] }, { id: '4', label: this.getLanguage['AFF']['TEMP4'] }];
            },
            getPayoutTypeList() {
                this.dd_payoutType = [{ id: '0', label: this.getLanguage['AFF']['PT0'] }, { id: '1', label: this.getLanguage['AFF']['PT1'] },];
                this.dd_AffiliatePayoutOption = [{ id: 0, label: this.getLanguage['PM']['MLY'] }, { id: 1, label: this.getLanguage['PM']['WLY'] }];
                this.dd_payoutBonusType = [{ id: '0', label: this.getLanguage['PM']['FA'] }, { id: '1', label: this.getLanguage['PM']['P'] },];
            },
            getMemberCount() {
                for (var i = 2; i <= 50; i++) {
                    this.dd_memcount.push({ id: i, label: i });
                }
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroupfs.length > 0) {
                                that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            getMaxLimit(value) {
                var that = this;
                this.getDataApi(`/api/aff/getMaxLimit/${value}`,
                    function (d, s) {
                        if (s) {
                            that.sportbookMaxLimit = d.SBML,
                                that.livecasinoMaxLimit = d.LCML,
                                that.slotMaxLimit = d.SML,
                                that.lotteryMaxLimit = d.LML,
                                that.fishingMaxLimit = d.FML,
                                that.ecasinoMaxLimit = d.ECML,
                                that.gamesMaxLimit = d.GML,
                                that.racingMaxLimit = d.RML
                        }
                    });
            },

            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");

                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (this.getUserInfo.AT == 0 && agi[0] == "0") {
                    item.isDisabled = false;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            getAFFList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                path += "&f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                this.getDataApi(`/api/aff/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setAFFList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setAFFList(data) {
                this.arry_aff = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);
                this.int_TI = data.TotalItems;
            },
            setAFF(data) {
                var that = this;
                this.ATSGC = null;
                this.obj_aaff = Object.assign(this.obj_aaff, data);
                var ATYS = [];
                for (var i = 0; i < 5; i++) {
                    ATYS[i] = {
                        T: i + 1,
                        RS: false,
                        TS: 0,
                    };

                    if (data.ATYS) {
                        data.ATYS.find(function (val, idx) {
                            if (val.T == i + 1) {
                                ATYS[i].T = val.T;
                                ATYS[i].RS = val.RS;
                                ATYS[i].TS = val.TS;
                            }
                        });
                    }
                }
                this.ATSV = ATYS[0].RS ? ATYS[0].RS : null;
                this.$set(this.$data.obj_aaff, 'ATYS', ATYS);

                if (this.obj_aaff.WT == 0) {
                    this.$set(this.$data.obj_aaff, 'WT', null);
                }

                if (this.obj_aaff.AT != null && this.obj_aaff.AT == 4) {
                    this.ddCategory = this.ddCategoryALL;
                }
                else {
                    this.ddCategory = this.ddCategoryList;
                }

                this.getMaxLimit(this.obj_aaff.AT);

                var AS = [];
                if (this.ddCategory.length > 0) {
                    if (this.obj_aaff.AT != null && this.obj_aaff.AT == 3) {
                        for (var i = 0; i < this.ddCategory.length; i++) {
                            AS[i] = {
                                RS: false,
                                T1: 0,
                                T2: 0,
                                T3: 0,
                                T4: 0,
                                T5: 0,
                                GCI: this.ddCategory[i].id,
                                GCN: this.ddCategory[i].label,

                            };

                            var gcid = this.ddCategory[i].id;
                            var gclbl = this.ddCategory[i].label;

                            if (data.AS) {
                                data.AS.find(function (val, idx) {
                                    if (val.GCI == that.ddCategory[i].id) {
                                        AS[i].RS = val.RS;
                                        AS[i].T1 = val.T1;
                                        AS[i].T2 = val.T2;
                                        AS[i].T3 = val.T3;
                                        AS[i].T4 = val.T4;
                                        AS[i].T5 = val.T5;
                                        AS[i].GCI = that.ddCategory[i].id;
                                        AS[i].GCN = that.ddCategory[i].label;

                                    }
                                });
                            }
                            if (AS[i].RS) {
                                this.ATSGC = true;
                            }
                        }
                    }
                    else {
                        for (var i = 0; i < this.ddCategory.length; i++) {
                            AS[i] = {
                                RS: false,
                                T1: 0,
                                T2: 0,
                                T3: 0,
                                T4: 0,
                                T5: 0,
                                GCI: this.ddCategory[i].id,
                                GCN: this.ddCategory[i].label,
                                ID: 0,
                                T1DL1: 0,
                                T1DL2: 0,
                                T1DL3: 0,
                                T1DL4: 0,
                                T2DL1: 0,
                                T2DL2: 0,
                                T2DL3: 0,
                                T2DL4: 0,
                                T3DL1: 0,
                                T3DL2: 0,
                                T3DL3: 0,
                                T3DL4: 0,
                                T4DL1: 0,
                                T4DL2: 0,
                                T4DL3: 0,
                                T4DL4: 0,
                                T5DL1: 0,
                                T5DL2: 0,
                                T5DL3: 0,
                                T5DL4: 0,
                                GPI: []
                            };

                            var gcid = this.ddCategory[i].id;
                            var gclbl = this.ddCategory[i].label;

                            if (this.obj_aaff.IMT == true) {
                                if (data.AS) {
                                    data.AS.find(function (val, idx) {
                                        if (val.GCI == that.ddCategory[i].id) {
                                            AS[i].RS = val.RS;
                                            AS[i].T1 = val.T1;
                                            AS[i].T2 = val.T2;
                                            AS[i].T3 = val.T3;
                                            AS[i].T4 = val.T4;
                                            AS[i].T5 = val.T5;
                                            AS[i].GCI = that.ddCategory[i].id;
                                            AS[i].GCN = that.ddCategory[i].label;
                                            AS[i].ID = val.ID;
                                            AS[i].T1DL1 = val.T1DL1;
                                            AS[i].T1DL2 = val.T1DL2;
                                            AS[i].T1DL3 = val.T1DL3;
                                            AS[i].T1DL4 = val.T1DL4;
                                            AS[i].T2DL1 = val.T2DL1;
                                            AS[i].T2DL2 = val.T2DL2;
                                            AS[i].T2DL3 = val.T2DL3;
                                            AS[i].T2DL4 = val.T2DL4;
                                            AS[i].T3DL1 = val.T3DL1;
                                            AS[i].T3DL2 = val.T3DL2;
                                            AS[i].T3DL3 = val.T3DL3;
                                            AS[i].T3DL4 = val.T3DL4;
                                            AS[i].T4DL1 = val.T4DL1;
                                            AS[i].T4DL2 = val.T4DL2;
                                            AS[i].T4DL3 = val.T4DL3;
                                            AS[i].T4DL4 = val.T4DL4;
                                            AS[i].T5DL1 = val.T5DL1;
                                            AS[i].T5DL2 = val.T5DL2;
                                            AS[i].T5DL3 = val.T5DL3;
                                            AS[i].T5DL4 = val.T5DL4;
                                            AS[i].GPI = val.GPI;
                                        }
                                    });
                                }
                            }
                            else {
                                if (data.AS) {
                                    data.AS.find(function (val, idx) {
                                        if (val.GCI == that.ddCategory[i].id) {
                                            AS[i].RS = val.RS;
                                            AS[i].T1 = val.T1;
                                            AS[i].T2 = val.T2;
                                            AS[i].T3 = val.T3;
                                            AS[i].T4 = val.T4;
                                            AS[i].T5 = val.T5;
                                            AS[i].GCI = that.ddCategory[i].id;
                                            AS[i].GCN = that.ddCategory[i].label;
                                            AS[i].ID = val.ID;
                                            AS[i].T1DL1 = val.T1;
                                            AS[i].T1DL2 = 0;
                                            AS[i].T1DL3 = 0;
                                            AS[i].T1DL4 = 0;
                                            AS[i].T2DL1 = val.T2;
                                            AS[i].T2DL2 = 0;
                                            AS[i].T2DL3 = 0;
                                            AS[i].T2DL4 = 0;
                                            AS[i].T3DL1 = val.T3;
                                            AS[i].T3DL2 = 0;
                                            AS[i].T3DL3 = 0;
                                            AS[i].T3DL4 = 0;
                                            AS[i].T4DL1 = val.T4;
                                            AS[i].T4DL2 = 0;
                                            AS[i].T4DL3 = 0;
                                            AS[i].T4DL4 = 0;
                                            AS[i].T5DL1 = val.T5;
                                            AS[i].T5DL2 = 0;
                                            AS[i].T5DL3 = 0;
                                            AS[i].T5DL4 = 0;
                                            AS[i].GPI = val.GPI;
                                        }
                                    });
                                }
                            }

                            if (AS[i].RS) {
                                this.ATSGC = true;
                            }
                        }
                    }
                }

                this.$set(this.$data.obj_aaff, 'AS', AS);

                var tnc = [];
                var tnc_list = [];
                tnc = this.$data.obj_aaff.R.split("{<=}");
                if (tnc.length > 0) {
                    tnc.forEach(function (item) {
                        var tnc_row = item.split("{=>}");
                        tnc_list[tnc_row[0]] = tnc_row[1];
                    });
                }
                this.array_tnc = tnc_list;
                this.bool_isAMV = true;
            },
            setDFAFF(data) {
                if (this.obj_aaff.AT != null && this.obj_aaff.AT == 4) {
                    this.ddCategory = this.ddCategoryALL;
                }
                else {
                    this.ddCategory = this.ddCategoryList;
                }

                var that = this;
                var AS = [];
                if (this.ddCategory.length > 0) {
                    for (var i = 0; i < this.ddCategory.length; i++) {
                        AS[i] = {
                            RS: false,
                            T1: 0,
                            T2: 0,
                            T3: 0,
                            T4: 0,
                            T5: 0,
                            GCI: this.ddCategory[i].id,
                            GCN: this.ddCategory[i].label,
                            ID: 0,
                            T1DL1: 0,
                            T1DL2: 0,
                            T1DL3: 0,
                            T1DL4: 0,
                            T2DL1: 0,
                            T2DL2: 0,
                            T2DL3: 0,
                            T2DL4: 0,
                            T3DL1: 0,
                            T3DL2: 0,
                            T3DL3: 0,
                            T3DL4: 0,
                            T4DL1: 0,
                            T4DL2: 0,
                            T4DL3: 0,
                            T4DL4: 0,
                            T5DL1: 0,
                            T5DL2: 0,
                            T5DL3: 0,
                            T5DL4: 0
                            //GPI: []
                        };

                        var gcid = this.ddCategory[i].id;
                        var gclbl = this.ddCategory[i].label;

                        if (data) {
                            data.find(function (val, idx) {
                                if (val.GCI == that.ddCategory[i].id) {
                                    AS[i].RS = true;
                                    AS[i].T1 = val.T1;
                                    AS[i].T2 = val.T2;
                                    AS[i].T3 = val.T3;
                                    AS[i].T4 = val.T4;
                                    AS[i].T5 = val.T5;
                                    AS[i].GCI = that.ddCategory[i].id;
                                    AS[i].GCN = that.ddCategory[i].label;
                                    AS[i].ID = val.ID;
                                    AS[i].T1DL1 = val.T1DL1;
                                    AS[i].T1DL2 = val.T1DL2;
                                    AS[i].T1DL3 = val.T1DL3;
                                    AS[i].T1DL4 = val.T1DL4;
                                    AS[i].T2DL1 = val.T2DL1;
                                    AS[i].T2DL2 = val.T2DL2;
                                    AS[i].T2DL3 = val.T2DL3;
                                    AS[i].T2DL4 = val.T2DL4;
                                    AS[i].T3DL1 = val.T3DL1;
                                    AS[i].T3DL2 = val.T3DL2;
                                    AS[i].T3DL3 = val.T3DL3;
                                    AS[i].T3DL4 = val.T3DL4;
                                    AS[i].T4DL1 = val.T4DL1;
                                    AS[i].T4DL2 = val.T4DL2;
                                    AS[i].T4DL3 = val.T4DL3;
                                    AS[i].T4DL4 = val.T4DL4;
                                    AS[i].T5DL1 = val.T5DL1;
                                    AS[i].T5DL2 = val.T5DL2;
                                    AS[i].T5DL3 = val.T5DL3;
                                    AS[i].T5DL4 = val.T5DL4;
                                    AS[i].GPI = val.GPI;
                                }
                            });
                        }

                        if (AS[i].RS) {
                            this.ATSGC = true;
                        }
                    }
                }

                this.$set(this.$data.obj_aaff, 'AS', AS);
            },
            addAFF() {
                this.obj_aaff = {
                    I: 0,
                    RS: 1,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    ATYS: [],
                    AS: [],
                    CI: null,
                    AGIT: null,
                    MAM: 2,
                    AT: null,
                    AGT: 3,
                    IT: null,
                    WT: null,
                    R: "",
                    MDA: 0,
                    RBA: 1,
                    IMT: false,
                    PT: 0,
                    IWLY: 0,
                    PBT: 0,
                    MXDA: 9999999,
                    PP: 0,
                    MPA: 0
                };
                this.ATSV = null;
                this.ATSGC = null;
                this.bool_CV = false;
                this.bool_isAMV = true;
                this.bool_showSaveBtn = true;
                this.bool_showMultiTierSaveBtn = true;
                this.dd_currency = [];
                this.LoopAffiliateSetup(false, this.obj_aaff.I, this.obj_aaff.AT);
                this.dd_language = [];
                this.array_tnc = [];
                this.currencySymbol = null;
                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.obj_aaff.AGIT = this.dd_agentgroup[0].id;
                        this.AgentGroupChange(this.obj_aaff.AGIT);
                    }
                }                
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    if (value == 'ATSV')
                        var validateObj = this.$v.ATSV;
                    else if (value == 'ATSGC')
                        var validateObj = this.$v.ATSGC;
                    else if (value == 'AMS')
                        var validateObj = this.$v.obj_aaffmt[value];
                    else
                        var validateObj = this.$v.obj_aaff[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AFF"][langKey]);
                    } else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["AFF"][langKey]);
                    }
                }

            },
            saveAFF() {
                this.bool_CV = true;
                var tnc = [];
                Object.keys(this.array_tnc).forEach(key => {
                    tnc.push(key + "{=>}" + this.array_tnc[key]);
                });
                if (tnc.length > 0) {
                    this.obj_aaff.R = tnc.join("{<=}");
                }

                this.$v.obj_aaff.$touch();
                this.$v.ATSV.$touch();
                this.$v.ATSGC.$touch();
                this.isMaxLimitValid = true;
                if (this.obj_aaff.IMT == true) {
                    this.checkMaxLimit2();
                }

                if (!this.$v.obj_aaff.$error && !this.$v.ATSV.$error && !this.$v.ATSGC.$error && this.isMaxLimitValid) {
                    if (this.obj_aaff.AGIT != null && this.obj_aaff.AGIT.length > 0) {
                        var agi = this.obj_aaff.AGIT.split("-");
                        this.obj_aaff.AGI = agi[1];
                    }

                    if (this.obj_aaff.AT == 3) {
                        this.obj_aaff.MAM = 0;
                    }

                    var that = this;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    this.postDataApi(`/api/aff/s`, this.obj_aaff,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.getAFFList();
                            }
                        });
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_aaff"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            ATChange(value) {
                this.obj_aaff.WT = null;
                if (this.obj_aaff.AGIT != null) {
                    this.AgentGroupChange(this.obj_aaff.AGIT);
                    this.getMaxLimit(value);
                }
            },
            tempChange(value) {
                if (this.obj_aaff.AT != null && value != null) {
                    this.bool_fullLoading = true;
                    this.obj_aaff.WT = value;
                    var that = this;
                    this.getDataApi(`/api/aff/getDefault/${this.obj_aaff.AT}/${value}/${this.obj_aaff.IMT}`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.setDFAFF(d);
                            }
                        });
                } else {
                    this.obj_aaff.WT = null;
                }
            },
            tempChangeIMT(value) {
                if (this.obj_aaff.AT != null && value != null && value != 0 && value != 4) {
                    this.bool_fullLoading = true;
                    this.obj_aaff.WT = value;
                    var that = this;
                    this.getDataApi(`/api/aff/getDefault/${this.obj_aaff.AT}/${value}/${this.obj_aaff.IMT}`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.setDFAFF(d);
                            }
                        });
                }
            },
            viewAFF(id) {
                this.bool_fullLoading = true;
                this.bool_showSaveBtn = this.checkModuleAccess2(constAccessType.edit);
                this.bool_showMultiTierSaveBtn = this.checkModuleAccess2(constAccessType.edit);
                var that = this;
                this.getDataApi(`/api/aff/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setAFF(d.D);
                            if (that.obj_aaff.AGI != 18) {
                                that.obj_aaff.AGIT = "3-" + that.obj_aaff.AGI;
                                that.obj_aaff.AGT = 3;
                                that.AgentGroupChange(that.obj_aaff.AGIT);
                            }
                            else if (that.obj_aaff.AGI == 18) {
                                that.obj_aaff.AGIT = "0-" + that.obj_aaff.AGI;
                                that.obj_aaff.AGT = 0;
                                that.AgentGroupChange(that.obj_aaff.AGIT);
                            }
                        }
                    });
            },
            editAFF(id) {
                this.bool_fullLoading = true;
                this.bool_showSaveBtn = true;
                this.bool_showMultiTierSaveBtn = true;
                var that = this;
                this.getDataApi(`/api/aff/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setAFF(d.D);
                            if (that.obj_aaff.AGI != 18) {
                                that.obj_aaff.AGIT = "3-" + that.obj_aaff.AGI;
                                that.obj_aaff.AGT = 3;
                                that.AgentGroupChange(that.obj_aaff.AGIT);
                            }
                            else if (that.obj_aaff.AGI == 18) {
                                that.obj_aaff.AGIT = "0-" + that.obj_aaff.AGI;
                                that.obj_aaff.AGT = 0;
                                that.AgentGroupChange(that.obj_aaff.AGIT);
                            }
                        }
                    });
            },
            updateAFFStatus(data) {
                this.$fire({
                    title: this.getLanguage["AFF"]["USM"] + ' ' + this.getLanguage["AFF"]["CFM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;

                        this.postDataApi(`/api/aff/uaffs`, data,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getAFFList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                    else {
                        this.getAFFList();
                    }
                });
            },
            removeAFF(data) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: data.I,
                            uts: data.UTS
                        };

                        this.postDataApi(`/api/aff/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getAFFList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            defaultThreshold(index) {
                if (this.obj_aaff.ATYS[index].TS == 0) {
                    this.obj_aaff.ATYS[index].TS = 99999999;
                }
                if (index == 0) {
                    this.ATSV = this.obj_aaff.ATYS[0].RS ? null : this.obj_aaff.ATYS[0].RS;
                }
            },
            defaultDeposit(index) {
                if (this.obj_aaff.MDA == 0) {
                    this.obj_aaff.MXDA = 99999999;
                }
                if (index == 0) {
                    // this.ATSV = this.obj_aaff.ATYS[0].RS ? null : this.obj_aaff.ATYS[0].RS;
                }
            },
            checkGameTiering(index) {
                this.ATSGC = null;
                if (this.obj_aaff.AS[index].RS) {
                    this.ATSGC = true;
                } else {
                    for (var i = 0; i < this.obj_aaff.AS.length; i++) {
                        if (this.obj_aaff.AS[i].RS) {
                            this.ATSGC = true;
                            break;
                        }
                    }
                }
            },
            renderPayoutMethod(value) {
                var pm = "-";
                if (value != 0) {
                    if (this.dd_view_pm.length > 0) {
                        for (var i = 0; i < this.dd_view_pm.length; i++) {
                            for (var j = 0; j < this.dd_view_pm[i].children.length; j++) {
                                if (this.dd_view_pm[i].children[j].id == value) {
                                    pm = this.dd_view_pm[i].label + ' - ' + this.dd_view_pm[i].children[j].label;
                                    break;
                                }
                            }
                        }
                    }
                    else {
                        this.getViewPMList();
                    }
                }
                return pm;
            },
            renderTemplate(value) {
                if (value != 0) {
                    return this.dd_temp[value - 1].label;
                }
                else {
                    return '-';
                }
            },
            renderPayoutType(value) {
                if (value != null) {
                    return this.dd_payoutType[value].label;
                }
                else {
                    return '-';
                }
            },
            renderPayoutDuration(value) {
                if (value != null) {
                    return this.dd_AffiliatePayoutOption[value].label;
                }
                else {
                    return '-';
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getAFFList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            clearDateRangeFilter() {
                this.str_FV[2].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            editMultiTiering(data, index) {
                this.bool_fullLoading = true;
                this.selectedGPCat = '0-2';
                var that = this;
                this.editMultiTierIndex = index;
                var dt = {
                    id: data.ID,
                    gci: data.GCI
                };

                this.obj_aaffmt = Object.assign(that.obj_aaffmt, data);
                this.getDetailDropdownList(false, dt.gci);
                if (data.GPI != null && data.GPI.length > 0) {
                    this.obj_aaffmt.GameProviderIds = data.GPI.split(',');
                }
                else {
                    this.obj_aaffmt.GameProviderIds = null;
                }

                this.checkMaxLimit(data, index);
                this.setAFFMultiTier(data);
                this.bool_fullLoading = false;

            },
            checkMaxLimit(data, index) {
                var that = this;
                that.isMaxLimitValid = true;

                if (data.GCI == 2) {
                    if (this.obj_aaff.AS[index].T1 > that.sportbookMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.sportbookMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T2 > that.sportbookMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.sportbookMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T3 > that.sportbookMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.sportbookMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T4 > that.sportbookMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.sportbookMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T5 > that.sportbookMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.sportbookMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                }
                else if (data.GCI == 4) {
                    if (this.obj_aaff.AS[index].T1 > that.livecasinoMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.livecasinoMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T2 > that.livecasinoMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.livecasinoMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T3 > that.livecasinoMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.livecasinoMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T4 > that.livecasinoMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.livecasinoMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T5 > that.livecasinoMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.livecasinoMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                }
                else if (data.GCI == 5) {
                    if (this.obj_aaff.AS[index].T1 > that.slotMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.slotMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T2 > that.slotMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.slotMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T3 > that.slotMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.slotMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T4 > that.slotMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.slotMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T5 > that.slotMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.slotMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                }
                else if (data.GCI == 7) {
                    if (this.obj_aaff.AS[index].T1 > that.lotteryMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.lotteryMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T2 > that.lotteryMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.lotteryMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T3 > that.lotteryMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.lotteryMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T4 > that.lotteryMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.lotteryMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T5 > that.lotteryMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.lotteryMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                }
                else if (data.GCI == 10) {
                    if (this.obj_aaff.AS[index].T1 > that.fishingMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.fishingMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T2 > that.fishingMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.fishingMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T3 > that.fishingMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.fishingMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T4 > that.fishingMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.fishingMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T5 > that.fishingMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.fishingMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                }
                else if (data.GCI == 12) {
                    if (this.obj_aaff.AS[index].T1 > that.ecasinoMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.ecasinoMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T2 > that.ecasinoMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.ecasinoMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T3 > that.ecasinoMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.ecasinoMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T4 > that.ecasinoMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.ecasinoMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T5 > that.ecasinoMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.ecasinoMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                }
                else if (data.GCI == 13) {
                    if (this.obj_aaff.AS[index].T1 > that.gamesMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.gamesMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T2 > that.gamesMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.gamesMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T3 > that.gamesMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.gamesMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T4 > that.gamesMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.gamesMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T5 > that.gamesMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.gamesMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                }
                else if (data.GCI == 14) {

                    if (this.obj_aaff.AS[index].T1 > that.racingMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T2 > that.racingMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T3 > that.racingMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T4 > that.racingMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T5 > that.racingMaxLimit) {
                        this.showErrorMessage(null, data.GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                }
                else if (data.GCI == 0) {
                    if (this.obj_aaff.AS[index].T1 > that.racingMaxLimit) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T2 > that.racingMaxLimit) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T3 > that.racingMaxLimit) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T4 > that.racingMaxLimit) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                    if (this.obj_aaff.AS[index].T5 > that.racingMaxLimit) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                        that.isMaxLimitValid = false;
                    }
                }
            },
            checkMaxLimit2() {
                var that = this;
                that.errormsg = "";
                that.isMaxLimitValid = true;
                if (that.obj_aaff.AT != 3) {
                    for (var i = 0; i < that.obj_aaff.AS.length; i++) {
                        if (that.obj_aaff.AS[i].GCI == 2) {
                            if (this.obj_aaff.AS[i].T1 > that.sportbookMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.sportbookMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.sportbookMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T2 > that.sportbookMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.sportbookMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.sportbookMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T3 > that.sportbookMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.sportbookMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.sportbookMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T4 > that.sportbookMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.sportbookMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.sportbookMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T5 > that.sportbookMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.sportbookMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.sportbookMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                        }
                        if (that.obj_aaff.AS[i].GCI == 4) {
                            if (this.obj_aaff.AS[i].T1 > that.livecasinoMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.livecasinoMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.livecasinoMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T2 > that.livecasinoMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.livecasinoMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.livecasinoMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T3 > that.livecasinoMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.livecasinoMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.livecasinoMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T4 > that.livecasinoMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.livecasinoMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.livecasinoMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T5 > that.livecasinoMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.livecasinoMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.livecasinoMaxLimit);
                                that.isMaxLimitValid = false;
                            }

                        }
                        if (that.obj_aaff.AS[i].GCI == 5) {
                            if (this.obj_aaff.AS[i].T1 > that.slotMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.slotMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.slotMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T2 > that.slotMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.slotMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.slotMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T3 > that.slotMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.slotMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.slotMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T4 > that.slotMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.slotMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.slotMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T5 > that.slotMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.slotMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.slotMaxLimit);
                                that.isMaxLimitValid = false;
                            }

                        }
                        if (that.obj_aaff.AS[i].GCI == 7) {
                            if (this.obj_aaff.AS[i].T1 > that.lotteryMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.lotteryMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.lotteryMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T2 > that.lotteryMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.lotteryMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.lotteryMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T3 > that.lotteryMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.lotteryMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.lotteryMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T4 > that.lotteryMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.lotteryMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.lotteryMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T5 > that.lotteryMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.lotteryMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.lotteryMaxLimit);
                                that.isMaxLimitValid = false;
                            }


                        }
                        if (that.obj_aaff.AS[i].GCI == 10) {
                            if (this.obj_aaff.AS[i].T1 > that.fishingMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.fishingMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.fishingMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T2 > that.fishingMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.fishingMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.fishingMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T3 > that.fishingMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.fishingMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.fishingMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T4 > that.fishingMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.fishingMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.fishingMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T5 > that.fishingMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.fishingMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.fishingMaxLimit);
                                that.isMaxLimitValid = false;
                            }


                        }
                        if (that.obj_aaff.AS[i].GCI == 12) {
                            if (this.obj_aaff.AS[i].T1 > that.ecasinoMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.ecasinoMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.ecasinoMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T2 > that.ecasinoMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.ecasinoMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.ecasinoMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T3 > that.ecasinoMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.ecasinoMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.ecasinoMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T4 > that.ecasinoMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.ecasinoMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.ecasinoMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T5 > that.ecasinoMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.ecasinoMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.ecasinoMaxLimit);
                                that.isMaxLimitValid = false;
                            }


                        }
                        if (that.obj_aaff.AS[i].GCI == 13) {
                            if (this.obj_aaff.AS[i].T1 > that.gamesMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.gamesMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.gamesMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T2 > that.gamesMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.gamesMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.gamesMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T3 > that.gamesMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.gamesMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.gamesMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T4 > that.gamesMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.gamesMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.gamesMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T5 > that.gamesMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.gamesMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.gamesMaxLimit);
                                that.isMaxLimitValid = false;
                            }


                        }
                        if (that.obj_aaff.AS[i].GCI == 14) {
                            if (this.obj_aaff.AS[i].T1 > that.racingMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T2 > that.racingMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T3 > that.racingMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T4 > that.racingMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T5 > that.racingMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                                that.errormsg += "<br />" + that.obj_aaff.AS[i].GCN + " " + String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit);
                                that.isMaxLimitValid = false;
                            }


                        }
                        if (that.obj_aaff.AS[i].GCI == 0) {
                            if (this.obj_aaff.AS[i].T1 > that.racingMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                                that.errormsg += String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T2 > that.racingMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                                that.errormsg += String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T3 > that.racingMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                                that.errormsg += String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T4 > that.racingMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                                that.errormsg += String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit);
                                that.isMaxLimitValid = false;
                            }
                            else if (this.obj_aaff.AS[i].T5 > that.racingMaxLimit) {
                                //this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit), 1000);
                                that.errormsg += String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), that.racingMaxLimit);
                                that.isMaxLimitValid = false;
                            }

                        }
                        if (that.isMaxLimitValid == false) {
                            this.showErrorMessage(null, that.errormsg, 1000);
                        }
                    }
                }
            },
            setAFFMultiTier(data) {
                var that = this;

                if (that.isMaxLimitValid) {
                    this.obj_aaffmt = Object.assign(this.obj_aaffmt, data);
                    //if ((that.obj_aaffmt.T1DL1 + that.obj_aaffmt.T1DL2 + that.obj_aaffmt.T1DL3 + that.obj_aaffmt.T1DL4) == 0) {
                    //    that.obj_aaffmt.T1DL1 = that.obj_aaffmt.T1;
                    //}
                    //if ((that.obj_aaffmt.T2DL1 + that.obj_aaffmt.T2DL2 + that.obj_aaffmt.T2DL3 + that.obj_aaffmt.T2DL4) == 0) {
                    //    that.obj_aaffmt.T2DL1 = that.obj_aaffmt.T2;
                    //}
                    //if ((that.obj_aaffmt.T3DL1 + that.obj_aaffmt.T3DL2 + that.obj_aaffmt.T3DL3 + that.obj_aaffmt.T3DL4) == 0) {
                    //    that.obj_aaffmt.T3DL1 = that.obj_aaffmt.T3;
                    //}
                    //if ((that.obj_aaffmt.T4DL1 + that.obj_aaffmt.T4DL2 + that.obj_aaffmt.T4DL3 + that.obj_aaffmt.T4DL4)== 0) {
                    //    that.obj_aaffmt.T4DL1 = that.obj_aaffmt.T4;
                    //}
                    //if ((that.obj_aaffmt.T5DL1 + that.obj_aaffmt.T5DL2 + that.obj_aaffmt.T5DL3 + that.obj_aaffmt.T5DL4) == 0) {
                    //    that.obj_aaffmt.T5DL1 = that.obj_aaffmt.T5;
                    //}
                    //that.obj_aaffmt.T1 = this.obj_aaff.AS[index].T1;
                    //that.obj_aaffmt.T1DL1 = data.T1DL1;
                    //that.obj_aaffmt.T1DL2 = data.T1DL2;
                    //that.obj_aaffmt.T1DL3 = data.T1DL3;
                    //that.obj_aaffmt.T1DL4 = data.T1DL4;
                    //that.obj_aaffmt.GCI = data.GCI;
                    //that.obj_aaffmt.ID = data.ID;

                    //that.obj_aaffmt.T2 = this.obj_aaff.AS[index].T2;
                    //that.obj_aaffmt.T2DL1 = data.T2DL1;
                    //that.obj_aaffmt.T2DL2 = data.T2DL2;
                    //that.obj_aaffmt.T2DL3 = data.T2DL3;
                    //that.obj_aaffmt.T2DL4 = data.T2DL4;

                    //that.obj_aaffmt.T3 = this.obj_aaff.AS[index].T3;
                    //that.obj_aaffmt.T3DL1 = data.T3DL1;
                    //that.obj_aaffmt.T3DL2 = data.T3DL2;
                    //that.obj_aaffmt.T3DL3 = data.T3DL3;
                    //that.obj_aaffmt.T3DL4 = data.T3DL4;

                    //that.obj_aaffmt.T4 = this.obj_aaff.AS[index].T4;
                    //that.obj_aaffmt.DL1 = data.T4DL1;
                    //that.obj_aaffmt.DL2 = data.T4DL2;
                    //that.obj_aaffmt.DL3 = data.T4DL3;
                    //that.obj_aaffmt.DL4 = data.T4DL4;

                    //that.obj_aaffmt.T5 = this.obj_aaff.AS[index].T5;
                    //that.obj_aaffmt.T5DL1 = data.T5DL1;
                    //that.obj_aaffmt.T5DL2 = data.T5DL2;
                    //that.obj_aaffmt.T5DL3 = data.T5DL3;
                    //that.obj_aaffmt.T5DL4 = data.T5DL4;

                    this.bool_isMultiTiering = true;
                }

            },

            saveAFFMultiTier() {
                this.bool_CV = true;
                let isValid = true;
                var that = this;

                if (this.obj_aaffmt.T1DL1 == null || this.obj_aaffmt.T1DL1 == '') {
                    this.obj_aaffmt.T1DL1 = 0;
                }
                if (this.obj_aaffmt.T1DL2 == null || this.obj_aaffmt.T1DL2 == '') {
                    this.obj_aaffmt.T1DL2 = 0;
                }
                if (this.obj_aaffmt.T1DL3 == null || this.obj_aaffmt.T1DL3 == '') {
                    this.obj_aaffmt.T1DL3 = 0;
                }
                if (this.obj_aaffmt.T1DL4 == null || this.obj_aaffmt.T1DL4 == '') {
                    this.obj_aaffmt.T1DL4 = 0;
                }
                if (this.obj_aaffmt.T2DL1 == null || this.obj_aaffmt.T2DL1 == '') {
                    this.obj_aaffmt.T2DL1 = 0;
                }
                if (this.obj_aaffmt.T2DL2 == null || this.obj_aaffmt.T2DL2 == '') {
                    this.obj_aaffmt.T2DL2 = 0;
                }
                if (this.obj_aaffmt.T2DL3 == null || this.obj_aaffmt.T2DL3 == '') {
                    this.obj_aaffmt.T2DL3 = 0;
                }
                if (this.obj_aaffmt.T2DL4 == null || this.obj_aaffmt.T2DL4 == '') {
                    this.obj_aaffmt.T2DL4 = 0;
                }
                if (this.obj_aaffmt.T3DL1 == null || this.obj_aaffmt.T3DL1 == '') {
                    this.obj_aaffmt.T3DL1 = 0;
                }
                if (this.obj_aaffmt.T3DL2 == null || this.obj_aaffmt.T3DL2 == '') {
                    this.obj_aaffmt.T3DL2 = 0;
                }
                if (this.obj_aaffmt.T3DL3 == null || this.obj_aaffmt.T3DL3 == '') {
                    this.obj_aaffmt.T3DL3 = 0;
                }
                if (this.obj_aaffmt.T3DL4 == null || this.obj_aaffmt.T3DL4 == '') {
                    this.obj_aaffmt.T3DL4 = 0;
                }
                if (this.obj_aaffmt.T4DL1 == null || this.obj_aaffmt.T4DL1 == '') {
                    this.obj_aaffmt.T4DL1 = 0;
                }
                if (this.obj_aaffmt.T4DL2 == null || this.obj_aaffmt.T4DL2 == '') {
                    this.obj_aaffmt.T4DL2 = 0;
                }
                if (this.obj_aaffmt.T4DL3 == null || this.obj_aaffmt.T4DL3 == '') {
                    this.obj_aaffmt.T4DL3 = 0;
                }
                if (this.obj_aaffmt.T4DL4 == null || this.obj_aaffmt.T4DL4 == '') {
                    this.obj_aaffmt.T4DL4 = 0;
                }
                if (this.obj_aaffmt.T5DL1 == null || this.obj_aaffmt.T5DL1 == '') {
                    this.obj_aaffmt.T5DL1 = 0;
                }
                if (this.obj_aaffmt.T5DL2 == null || this.obj_aaffmt.T5DL2 == '') {
                    this.obj_aaffmt.T5DL2 = 0;
                }
                if (this.obj_aaffmt.T5DL3 == null || this.obj_aaffmt.T5DL3 == '') {
                    this.obj_aaffmt.T5DL3 = 0;
                }
                if (this.obj_aaffmt.T5DL4 == null || this.obj_aaffmt.T5DL4 == '') {
                    this.obj_aaffmt.T5DL4 = 0;
                }
                if (this.obj_aaffmt.T1 == null || this.obj_aaffmt.T1 == '') {
                    this.obj_aaffmt.T1 = 0;
                }
                if (this.obj_aaffmt.T2 == null || this.obj_aaffmt.T2 == '') {
                    this.obj_aaffmt.T2 = 0;
                }
                if (this.obj_aaffmt.T3 == null || this.obj_aaffmt.T3 == '') {
                    this.obj_aaffmt.T3 = 0;
                }
                if (this.obj_aaffmt.T4 == null || this.obj_aaffmt.T4 == '') {
                    this.obj_aaffmt.T4 = 0;
                }
                if (this.obj_aaffmt.T5 == null || this.obj_aaffmt.T5 == '') {
                    this.obj_aaffmt.T5 = 0;
                }

                var T1DLAmount = 0;
                T1DLAmount += parseFloat(this.obj_aaffmt.T1DL1);
                T1DLAmount += parseFloat(this.obj_aaffmt.T1DL2);
                T1DLAmount += parseFloat(this.obj_aaffmt.T1DL3);
                T1DLAmount += parseFloat(this.obj_aaffmt.T1DL4);

                var T2DLAmount = 0;
                T2DLAmount += parseFloat(this.obj_aaffmt.T2DL1);
                T2DLAmount += parseFloat(this.obj_aaffmt.T2DL2);
                T2DLAmount += parseFloat(this.obj_aaffmt.T2DL3);
                T2DLAmount += parseFloat(this.obj_aaffmt.T2DL4);

                var T3DLAmount = 0;
                T3DLAmount += parseFloat(this.obj_aaffmt.T3DL1);
                T3DLAmount += parseFloat(this.obj_aaffmt.T3DL2);
                T3DLAmount += parseFloat(this.obj_aaffmt.T3DL3);
                T3DLAmount += parseFloat(this.obj_aaffmt.T3DL4);

                var T4DLAmount = 0;
                T4DLAmount += parseFloat(this.obj_aaffmt.T4DL1);
                T4DLAmount += parseFloat(this.obj_aaffmt.T4DL2);
                T4DLAmount += parseFloat(this.obj_aaffmt.T4DL3);
                T4DLAmount += parseFloat(this.obj_aaffmt.T4DL4);

                var T5DLAmount = 0;
                T5DLAmount += parseFloat(this.obj_aaffmt.T5DL1);
                T5DLAmount += parseFloat(this.obj_aaffmt.T5DL2);
                T5DLAmount += parseFloat(this.obj_aaffmt.T5DL3);
                T5DLAmount += parseFloat(this.obj_aaffmt.T5DL4);

                if (that.obj_aaffmt.T1 < T1DLAmount.toFixed(3)) {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), this.obj_aaffmt.T1), 1000);
                    isValid = false;
                }
                if (that.obj_aaffmt.T2 < T2DLAmount.toFixed(3)) {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), this.obj_aaffmt.T2), 1000);
                    isValid = false;
                }
                if (that.obj_aaffmt.T3 < T3DLAmount.toFixed(3)) {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), this.obj_aaffmt.T3), 1000);
                    isValid = false;
                }
                if (that.obj_aaffmt.T4 < T4DLAmount.toFixed(3)) {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), this.obj_aaffmt.T4), 1000);
                    isValid = false;
                }
                if (that.obj_aaffmt.T5 < T5DLAmount.toFixed(3)) {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), this.obj_aaffmt.T5), 1000);
                    isValid = false;
                }
                if (isValid) {
                    this.obj_aaffmt.GPI = "";
                    if (this.obj_aaffmt.GameProviderIds != null && this.obj_aaffmt.GameProviderIds.length > 0) {
                        this.obj_aaffmt.GPI = this.obj_aaffmt.GameProviderIds.join(',');
                    }
                    this.obj_aaff.AS[this.editMultiTierIndex] = this.obj_aaffmt;
                    this.obj_aaffmt = {};
                    this.editMultiTierIndex = -1;
                    this.bool_CV = false;
                    this.bool_isMultiTiering = false;
                }

            },
            checkEnableMultiTier(v) {
                this.obj_aaff.IMT = v.target.checked;
                if (this.obj_aaff.I == 0) {
                    this.obj_aaff.WT = 4;
                }
                this.tempChangeIMT(this.obj_aaff.WT);
                this.$forceUpdate();
            },
            CalculateCPCT(Type, T, CS) {
                //var MaxLimit = 0;
                //if (this.obj_aaffmt.GCI != 5 && this.obj_aaff.AT != 4) {
                //    MaxLimit = this.gamesMaxLimit;
                //}
                //else if (this.obj_aaffmt.GCI != 5 && this.obj_aaff.AT == 4) {
                //    MaxLimit = this.allMaxLimit
                //}
                //else if (this.obj_aaffmt.GCI == 5) {
                //    MaxLimit = this.slotMaxLimit
                //}

                var amount = 0;
                if (Type == 1) {
                    amount += parseFloat(this.obj_aaffmt.T1DL1);
                    amount += parseFloat(this.obj_aaffmt.T1DL2);
                    amount += parseFloat(this.obj_aaffmt.T1DL3);
                    amount += parseFloat(this.obj_aaffmt.T1DL4);
                    T = amount.toFixed(3);
                    if (T > this.obj_aaffmt.T1) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), this.obj_aaffmt.T1), 1000);
                    }
                    //this.obj_aaffmt.T1 = T;
                }
                if (Type == 2) {
                    amount += parseFloat(this.obj_aaffmt.T2DL1);
                    amount += parseFloat(this.obj_aaffmt.T2DL2);
                    amount += parseFloat(this.obj_aaffmt.T2DL3);
                    amount += parseFloat(this.obj_aaffmt.T2DL4);
                    T = amount.toFixed(3);
                    if (T > this.obj_aaffmt.T2) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), this.obj_aaffmt.T2), 1000);
                    }
                    //this.obj_aaffmt.T2 = T;
                }
                if (Type == 3) {
                    amount += parseFloat(this.obj_aaffmt.T3DL1);
                    amount += parseFloat(this.obj_aaffmt.T3DL2);
                    amount += parseFloat(this.obj_aaffmt.T3DL3);
                    amount += parseFloat(this.obj_aaffmt.T3DL4);
                    T = amount.toFixed(3);
                    if (T > this.obj_aaffmt.T3) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), this.obj_aaffmt.T3), 1000);
                    }
                    //this.obj_aaffmt.T3 = T;
                }
                if (Type == 4) {
                    amount += parseFloat(this.obj_aaffmt.T4DL1);
                    amount += parseFloat(this.obj_aaffmt.T4DL2);
                    amount += parseFloat(this.obj_aaffmt.T4DL3);
                    amount += parseFloat(this.obj_aaffmt.T4DL4);
                    T = amount.toFixed(3);
                    if (T > this.obj_aaffmt.T4) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), this.obj_aaffmt.T4), 1000);
                    }
                    //this.obj_aaffmt.T4 = T;
                }
                if (Type == 5) {
                    amount += parseFloat(this.obj_aaffmt.T5DL1);
                    amount += parseFloat(this.obj_aaffmt.T5DL2);
                    amount += parseFloat(this.obj_aaffmt.T5DL3);
                    amount += parseFloat(this.obj_aaffmt.T5DL4);
                    T = amount.toFixed(3);
                    if (T > this.obj_aaffmt.T5) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), this.obj_aaffmt.T5), 1000);
                    }
                    //this.obj_aaffmt.T5 = T;
                }
                //if (T > MaxLimit) {
                //    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), MaxLimit), 1000);
                //}
                return T;
            },
            CheckCPCT(Tier) {
                var amount = 0;
                if (Tier == 1) {
                    amount += parseFloat(this.obj_aaffmt.T1DL1);
                    amount += parseFloat(this.obj_aaffmt.T1DL2);
                    amount += parseFloat(this.obj_aaffmt.T1DL3);
                    amount += parseFloat(this.obj_aaffmt.T1DL4);
                    if (amount.toFixed(3) > this.obj_aaffmt.T1) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), this.obj_aaffmt.T1), 1000);
                    }
                }
                if (Tier == 2) {
                    amount += parseFloat(this.obj_aaffmt.T2DL1);
                    amount += parseFloat(this.obj_aaffmt.T2DL2);
                    amount += parseFloat(this.obj_aaffmt.T2DL3);
                    amount += parseFloat(this.obj_aaffmt.T2DL4);
                    if (amount.toFixed(3) > this.obj_aaffmt.T2) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), this.obj_aaffmt.T2), 1000);
                    }
                }
                if (Tier == 3) {
                    amount += parseFloat(this.obj_aaffmt.T3DL1);
                    amount += parseFloat(this.obj_aaffmt.T3DL2);
                    amount += parseFloat(this.obj_aaffmt.T3DL3);
                    amount += parseFloat(this.obj_aaffmt.T3DL4);
                    if (amount.toFixed(3) > this.obj_aaffmt.T3) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), this.obj_aaffmt.T3), 1000);
                    }
                }
                if (Tier == 4) {
                    amount += parseFloat(this.obj_aaffmt.T4DL1);
                    amount += parseFloat(this.obj_aaffmt.T4DL2);
                    amount += parseFloat(this.obj_aaffmt.T4DL3);
                    amount += parseFloat(this.obj_aaffmt.T4DL4);
                    if (amount.toFixed(3) > this.obj_aaffmt.T4) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), this.obj_aaffmt.T4), 1000);
                    }
                }
                if (Tier == 5) {
                    amount += parseFloat(this.obj_aaffmt.T5DL1);
                    amount += parseFloat(this.obj_aaffmt.T5DL2);
                    amount += parseFloat(this.obj_aaffmt.T5DL3);
                    amount += parseFloat(this.obj_aaffmt.T5DL4);
                    if (amount.toFixed(3) > this.obj_aaffmt.T5) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1035'), this.utilGetErrorLanguage("AFF.CPCT"), this.obj_aaffmt.T5), 1000);
                    }
                }
            },
            TextValueChange(type, event) {
                if (type == "T1DL1") {
                    this.obj_aaffmt.T1DL1 = event.target.value;
                    if (this.obj_aaffmt.T1DL1 == null || this.obj_aaffmt.T1DL1 == '' || isNaN(this.obj_aaffmt.T1DL1) == true) {
                        this.obj_aaffmt.T1DL1 = 0;
                    }
                    this.CheckCPCT(1);
                    //this.CalculateCPCT(1,this.obj_aaffmt.T1, 2);
                }
                if (type == "T1DL2") {
                    this.obj_aaffmt.T1DL2 = event.target.value;
                    if (this.obj_aaffmt.T1DL2 == null || this.obj_aaffmt.T1DL2 == '' || isNaN(this.obj_aaffmt.T1DL2) == true) {
                        this.obj_aaffmt.T1DL2 = 0;
                    }
                    this.CheckCPCT(1);
                    //this.CalculateCPCT(1, this.obj_aaffmt.T1, 2);
                }
                if (type == "T1DL3") {
                    this.obj_aaffmt.T1DL3 = event.target.value;
                    if (this.obj_aaffmt.T1DL3 == null || this.obj_aaffmt.T1DL3 == '' || isNaN(this.obj_aaffmt.T1DL3) == true) {
                        this.obj_aaffmt.T1DL3 = 0;
                    }
                    this.CheckCPCT(1);
                    //this.CalculateCPCT(1, this.obj_aaffmt.T1, 2);
                }
                if (type == "T1DL4") {
                    this.obj_aaffmt.T1DL4 = event.target.value;
                    if (this.obj_aaffmt.T1DL4 == null || this.obj_aaffmt.T1DL4 == '' || isNaN(this.obj_aaffmt.T1DL4) == true) {
                        this.obj_aaffmt.T1DL4 = 0;
                    }
                    this.CheckCPCT(1);
                    //this.CalculateCPCT(1, this.obj_aaffmt.T1, 2);
                }

                if (type == "T2DL1") {
                    this.obj_aaffmt.T2DL1 = event.target.value;
                    if (this.obj_aaffmt.T2DL1 == null || this.obj_aaffmt.T2DL1 == '' || isNaN(this.obj_aaffmt.T2DL1) == true) {
                        this.obj_aaffmt.T2DL1 = 0;
                    }
                    this.CheckCPCT(2);
                    //this.CalculateCPCT(2, this.obj_aaffmt.T1, 2);
                }
                if (type == "T2DL2") {
                    this.obj_aaffmt.T2DL2 = event.target.value;
                    if (this.obj_aaffmt.T2DL2 == null || this.obj_aaffmt.T2DL2 == '' || isNaN(this.obj_aaffmt.T2DL2) == true) {
                        this.obj_aaffmt.T2DL2 = 0;
                    }
                    this.CheckCPCT(2);
                    //this.CalculateCPCT(2, this.obj_aaffmt.T1, 2);
                }
                if (type == "T2DL3") {
                    this.obj_aaffmt.T2DL3 = event.target.value;
                    if (this.obj_aaffmt.T2DL3 == null || this.obj_aaffmt.T2DL3 == '' || isNaN(this.obj_aaffmt.T2DL3) == true) {
                        this.obj_aaffmt.T2DL3 = 0;
                    }
                    this.CheckCPCT(2);
                    //this.CalculateCPCT(2, this.obj_aaffmt.T1, 2);
                }
                if (type == "T2DL4") {
                    this.obj_aaffmt.T2DL4 = event.target.value;
                    if (this.obj_aaffmt.T2DL4 == null || this.obj_aaffmt.T2DL4 == '' || isNaN(this.obj_aaffmt.T2DL4) == true) {
                        this.obj_aaffmt.T2DL4 = 0;
                    }
                    this.CheckCPCT(2);
                    //this.CalculateCPCT(2, this.obj_aaffmt.T1, 2);
                }

                if (type == "T3DL1") {
                    this.obj_aaffmt.T3DL1 = event.target.value;
                    if (this.obj_aaffmt.T3DL1 == null || this.obj_aaffmt.T3DL1 == '' || isNaN(this.obj_aaffmt.T3DL1) == true) {
                        this.obj_aaffmt.T3DL1 = 0;
                    }
                    this.CheckCPCT(3);
                    //this.CalculateCPCT(3, this.obj_aaffmt.T1, 2);
                }
                if (type == "T3DL2") {
                    this.obj_aaffmt.T3DL2 = event.target.value;
                    if (this.obj_aaffmt.T3DL2 == null || this.obj_aaffmt.T3DL2 == '' || isNaN(this.obj_aaffmt.T3DL2) == true) {
                        this.obj_aaffmt.T3DL2 = 0;
                    }
                    this.CheckCPCT(3);
                    //this.CalculateCPCT(3, this.obj_aaffmt.T1, 2);
                }
                if (type == "T3DL3") {
                    this.obj_aaffmt.T3DL3 = event.target.value;
                    if (this.obj_aaffmt.T3DL3 == null || this.obj_aaffmt.T3DL3 == '' || isNaN(this.obj_aaffmt.T3DL3) == true) {
                        this.obj_aaffmt.T3DL3 = 0;
                    }
                    this.CheckCPCT(3);
                    //this.CalculateCPCT(3, this.obj_aaffmt.T1, 2);
                }
                if (type == "T3DL4") {
                    this.obj_aaffmt.T3DL4 = event.target.value;
                    if (this.obj_aaffmt.T3DL4 == null || this.obj_aaffmt.T3DL4 == '' || isNaN(this.obj_aaffmt.T3DL4) == true) {
                        this.obj_aaffmt.T3DL4 = 0;
                    }
                    this.CheckCPCT(3);
                    //this.CalculateCPCT(3, this.obj_aaffmt.T1, 2);
                }
                if (type == "T4DL1") {
                    this.obj_aaffmt.T4DL1 = event.target.value;
                    if (this.obj_aaffmt.T4DL1 == null || this.obj_aaffmt.T4DL1 == '' || isNaN(this.obj_aaffmt.T4DL1) == true) {
                        this.obj_aaffmt.T4DL1 = 0;
                    }
                    this.CheckCPCT(4);
                    //this.CalculateCPCT(4, this.obj_aaffmt.T1, 2);
                }
                if (type == "T4DL2") {
                    this.obj_aaffmt.T4DL2 = event.target.value;
                    if (this.obj_aaffmt.T4DL2 == null || this.obj_aaffmt.T4DL2 == '' || isNaN(this.obj_aaffmt.T4DL2) == true) {
                        this.obj_aaffmt.T4DL2 = 0;
                    }
                    this.CheckCPCT(4);
                    //this.CalculateCPCT(4, this.obj_aaffmt.T1, 2);
                }
                if (type == "T4DL3") {
                    this.obj_aaffmt.T4DL3 = event.target.value;
                    if (this.obj_aaffmt.T4DL3 == null || this.obj_aaffmt.T4DL3 == '' || isNaN(this.obj_aaffmt.T4DL3) == true) {
                        this.obj_aaffmt.T4DL3 = 0;
                    }
                    this.CheckCPCT(4);
                    //this.CalculateCPCT(4, this.obj_aaffmt.T1, 2);
                }
                if (type == "T4DL4") {
                    this.obj_aaffmt.T4DL4 = event.target.value;
                    if (this.obj_aaffmt.T4DL4 == null || this.obj_aaffmt.T4DL4 == '' || isNaN(this.obj_aaffmt.T4DL4) == true) {
                        this.obj_aaffmt.T4DL4 = 0;
                    }
                    this.CheckCPCT(4);
                    //this.CalculateCPCT(4, this.obj_aaffmt.T1, 2);
                }
                if (type == "T5DL1") {
                    this.obj_aaffmt.T5DL1 = event.target.value;
                    if (this.obj_aaffmt.T5DL1 == null || this.obj_aaffmt.T5DL1 == '' || isNaN(this.obj_aaffmt.T5DL1) == true) {
                        this.obj_aaffmt.T5DL1 = 0;
                    }
                    this.CheckCPCT(5);
                    //this.CalculateCPCT(5, this.obj_aaffmt.T1, 2);
                }
                if (type == "T5DL2") {
                    this.obj_aaffmt.T5DL2 = event.target.value;
                    if (this.obj_aaffmt.T5DL2 == null || this.obj_aaffmt.T5DL2 == '' || isNaN(this.obj_aaffmt.T5DL2) == true) {
                        this.obj_aaffmt.T5DL2 = 0;
                    }
                    this.CheckCPCT(5);
                    //this.CalculateCPCT(5, this.obj_aaffmt.T1, 2);
                }
                if (type == "T5DL3") {
                    this.obj_aaffmt.T5DL3 = event.target.value;
                    if (this.obj_aaffmt.T5DL3 == null || this.obj_aaffmt.T5DL3 == '' || isNaN(this.obj_aaffmt.T5DL3) == true) {
                        this.obj_aaffmt.T5DL3 = 0;
                    }
                    this.CheckCPCT(5);
                    //this.CalculateCPCT(5, this.obj_aaffmt.T1, 2);
                }
                if (type == "T5DL4") {
                    this.obj_aaffmt.T5DL4 = event.target.value;
                    if (this.obj_aaffmt.T5DL4 == null || this.obj_aaffmt.T5DL4 == '' || isNaN(this.obj_aaffmt.T5DL4) == true) {
                        this.obj_aaffmt.T5DL4 = 0;
                    }
                    this.CheckCPCT(5);
                    //this.CalculateCPCT(5, this.obj_aaffmt.T1, 2);
                }

                //this.$forceUpdate();
            },
            getDetailDropdownList(bool_showForm, GCI) {
                var that = this;
                var int_loaded = 0;
                this.dd_gameprovider = [];
                //this.getDataApi('/api/dd/game/provbycur/0/1/' + this.obj_aaff.CI,
                this.getDataApi('/api/dd/game/provbycategory/0/' + GCI,
                    function (d, s) {
                        if (s && d.dropdownlist && d.dropdownlist.length > 0) {
                            for (var j = 0; j < d.dropdownlist.length; j++) {

                                if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                    for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                        if (d.dropdownlist[j].children[l].label in that.getLanguage['GP'])
                                            d.dropdownlist[j].children[l].label = that.getLanguage['GP'][d.dropdownlist[j].children[l].label];
                                    }
                                }
                            }
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderCategory(d.dropdownlist[i].id);
                            }
                            that.dd_gameprovider = that.appendSelectAllOption(d.dropdownlist);
                        }

                        int_loaded++;

                        if (int_loaded == 4 && bool_showForm) {
                            that.bool_fullLoading = false;
                            that.bool_isAMV = true;
                        }
                    });

            },
            renderCategory(id) {
                var gc = "";
                if (id == 0) {
                    gc = this.getLanguage["AFF"]["PM4"];
                } else {
                    gc = this.getLanguage["GC"][id];
                }
                return gc;
            },
            resetColumn(headerName) {
                var that = this;

                if (!that.checkModuleAccess2(constAccessType.edit)) {
                    that.removeDefaultColumn('RS')
                }

                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            getDropdownList() {                                
                this.getCategory();                
                this.getPMList();
                this.getViewPMList();
                this.getTEMPList();
                this.getPayoutTypeList();                
            },
        },
    }

</script>
<style>
    .range-slider {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Affiliate/AffiliateSetting.vue